import $ from 'jquery';
import Dropzone from '@public/packages/dropzone/dist/dropzone.js';
import * as itiUtils from '@public/packages/intl-tel-input/build/js/utils.js';
import { validateForm } from '@/js/helpers/validation.js';

/*
THIS IS A SOURCE FILE WHICH ENDS UP IN public_html/front/dst/js/app.js by GULPFILE!
    BUT IT WAS SYSTEMATICALLY FORGOTEN AND ONLY DESTINATION FILE public_html/front/dst/js/app.js was updated and edited
WHEN THE TIME COMES, MOVE NEWEST public_html/front/dst/js/app.js IN HERE, RUN THE GULP, ADD MINIMIZER AND CHECK THAT EVERYTHING WORKS!
*/

Dropzone.autoDiscover = false;

$(function() {
    $(".upload-box").each(function() {
        var id = $(this).attr("data-id");
        var container = $("#field" + id);
        // Init plupload
        $(this).dropzone({
            dictDefaultMessage: translations.uploadMessage,

            url: baseUrl + 'files/plupload',
            init: function() {
                this.on("success", function(file, data) {
                    data = JSON.parse(data);
                    if(data.success){
                        $("input.input-" + id).val(data.upload_data.file_name);
                    } else {
                        this.removeFile(file);
                        makeInfoBar(data.error_message, 'warning', 500, 8000);
                    }
                });
            }
        });
    });
});

window.entrio = window.entrio || {};


window.entrio.entrioApp = angular.module('entrioApp', ["ngMessages", "ngAnimate",'google.places'])

    .controller('sharedFrontController', ['$scope', '$rootScope', '$compile', function($scope, $rootScope, $compile) {
        $rootScope.euro_transition_header_alert = euro_transition_header_alert;
        $rootScope.marginAndPaddingTop = 0;
        $rootScope.currentUser = {
            info: {},
            isLoggedIn: null,
        };
        $("#langSelect").on('change', function(){
            window.location.href = this.value;
        });

        $scope.marginTopHeader = function (){
            if($rootScope.euro_transition_header_alert){
                let heightOfAlert = $('.organizers-bar').is(':visible') ? $('.organizers-bar').height() : 0;
                $rootScope.marginAndPaddingTop = heightOfAlert;
                if($rootScope.currentUser.isLoggedIn && $rootScope.userStats.length > 0){
                    $rootScope.marginAndPaddingTop = heightOfAlert + ($('.organizers-bar.header-top').is(':visible') ? $('.organizers-bar.header-top').height() : 0);
                }
            }else{
                if($rootScope.currentUser.isLoggedIn && $rootScope.userStats.length > 0){
                    $rootScope.marginAndPaddingTop = $('.organizers-bar.header-top').is(':visible') ? $('.organizers-bar.header-top').height() : 0;
                }
            }

            $scope.$applyAsync();
        }
        $scope.marginTopHeader();

        $rootScope.$watch('currentUser.isLoggedIn', function(){
            $scope.marginTopHeader();
        });

        $(window).on('resize', function(){
            $scope.marginTopHeader();
        });

        $scope.processRegisterForm = function(form, e){
            e.preventDefault();
            $scope.formFBDataLoading = false;

            form.$setSubmitted(true);

            if (form.$invalid) {
                $scope.formFBDataLoading = false;
                return false;
            }

            $scope.formFBDataLoading = true;
            $.ajax(
                {
                    url: siteUrl + 'me/complete_fb_registration',
                    type:"POST",
                    data: {
                        email:  $rootScope.currentUser.info.email,
                        first_name: $rootScope.currentUser.info.firstName,
                        last_name: $rootScope.currentUser.info.lastName,
                        newsletterSubscribe: $rootScope.currentUser.info.newsletter_subscribe ? 1 : 0

                    },

                }).done(function(data){
                $scope.formFBDataLoading = false;
                data = JSON.parse(data);

                makeInfoBar(data.message, detect_notification_severity(data), 500, 8000);
                if (data.success) {
                    $rootScope.closeFbModal();
                }
                $scope.$apply();
            });
        }

        $scope.outletsList = false;
        $scope.toggleOutletsList =  function(){
            $scope.outletsList = !$scope.outletsList;
        }

        function initContactMap() {

            if ($("#map").length === 0){
                return;
            }
            // Basic options for a simple Google Map
            // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
            var mapOptions = {
                // How zoomed in you want the map to start at (always required)
                zoom: 17,
                scrollwheel: false,
                disableDefaultUI: true,
                // The latitude and longitude to center the map (always required)
                center: new google.maps.LatLng(entrio_company_coordinates[0], entrio_company_coordinates[1]), // New York
                zoomControl: true,
                // How you would like to style the map.
                // This is where you would paste any style found on Snazzy Maps.
                //styles: [{"featureType": "water", "elementType": "geometry", "stylers": [{"color": "#000000"}, {"lightness": 17}]}, {"featureType": "landscape", "elementType": "geometry", "stylers": [{"color": "#000000"}, {"lightness": 20}]}, {"featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{"color": "#000000"}, {"lightness": 17}]}, {"featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{"color": "#000000"}, {"lightness": 29}, {"weight": 0.2}]}, {"featureType": "road.arterial", "elementType": "geometry", "stylers": [{"color": "#000000"}, {"lightness": 18}]}, {"featureType": "road.local", "elementType": "geometry", "stylers": [{"color": "#000000"}, {"lightness": 16}]}, {"featureType": "poi", "elementType": "geometry", "stylers": [{"color": "#000000"}, {"lightness": 21}]}, {"elementType": "labels.text.stroke", "stylers": [{"visibility": "on"}, {"color": "#000000"}, {"lightness": 16}]}, {"elementType": "labels.text.fill", "stylers": [{"saturation": 36}, {"color": "#000000"}, {"lightness": 40}]}, {"elementType": "labels.icon", "stylers": [{"visibility": "off"}]}, {"featureType": "transit", "elementType": "geometry", "stylers": [{"color": "#000000"}, {"lightness": 19}]}, {"featureType": "administrative", "elementType": "geometry.fill", "stylers": [{"color": "#000000"}, {"lightness": 20}]}, {"featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{"color": "#000000"}, {"lightness": 17}, {"weight": 1.2}]}]
            };

// Get the HTML DOM element that will contain your map
// We are using a div with id="map" seen below in the <body>
            var mapElement = document.getElementById('map');

// Create the Google Map using our element and options defined above
            var map = new google.maps.Map(mapElement, mapOptions);

            var marker = new google.maps.Marker({
                map: map,
                icon: {
                    url: baseUrl + 'images/map/entrio_door_gmaps_36i.png',
                },
                shadow: {
                    url: baseUrl + 'images/map/entrio_door_gmaps_36s.png',
                    anchor: new google.maps.Point(18, 44)
                },
                position: new google.maps.LatLng(entrio_company_coordinates[0], entrio_company_coordinates[1]),
            });

            var infoBubble = new InfoBubble({
                map: map,
                content: '<div class="mylabel"></div>',
                position: new google.maps.LatLng(entrio_company_coordinates[0], entrio_company_coordinates[1]),
                shadowStyle: 0,
                padding: 0,
                backgroundColor: 'transparent',
                borderRadius: 0,
                arrowSize: 10,
                borderWidth: 0,
                borderColor: '#322F31',
                disableAutoPan: true,
                hideCloseButton: true,
                arrowPosition: 50,
                arrowStyle: 0
            });

            google.maps.event.addListener(marker, 'click', function() {
                //infoBubble.open();
            });
        }

        if ($("#map").length > 0) {
            google.maps.event.addDomListener(window, 'load', initContactMap);
        }


    }]);

window.entrio.entrioApp.directive('timeEventsTemplateCompile', function($compile) {
    return {
        restrict: 'E',
        link: link
    }

    function link(scope, elem, attrs) {
        attrs.$observe('template', (template) => {
            elem.html(template);
            $compile(elem.contents())(scope);
        });
    }
});

window.entrio.entrioApp.config(function($animateProvider) {
    $animateProvider.classNameFilter(/angular-animate/);
})

window.entrio.entrioApp.config(['$compileProvider', function($compileProvider) {
    $compileProvider.strictDi = true;
}]);

window.entrio.entrioApp.controller('ticketsListController', ['$scope', '$rootScope', '$compile', '$sce', function($scope, $rootScope, $compile, $sce) {

    $(".stream-placeholder, .event-banner").click(function (){
        if($(this).hasClass( "clickable" )){
            return;
        }

        if($(".js-StreamCountdown").length){
            $('html,body').animate({scrollTop: $(".js-StreamCountdown").offset().top-90},'slow');
        }else if($(".event-tickets").length){
            $('html,body').animate({scrollTop: $(".event-tickets").offset().top-90},'slow');
        }
    });

    $scope.scrollToMap = function() {
        if ($(".seats-chart #chart").length) {
            $('html, body').animate({
                scrollTop: $(".seats-chart #chart").offset().top - 100
            }, 250);
        } else if ($("#eventsTime").length) {
            $('html, body').animate({
                scrollTop: $("#eventsTime").offset().top - 100
            }, 250);
        }
    }

    $scope.ticketCategories = {};
    $scope.shoppingBasket = [];
    $scope.shoppingBasketTotal = 0;
    $scope.shoppingBasketTotalEur = 0;
    $scope.discountStatus = -1;
    $scope.addToShoppingBasket = function(item) {
        $scope.shoppingBasket.push(item);
        $scope.$apply();
        if ($scope.promoCode !== ""){
            $scope.recalculate_discount();
        }
        $scope.calculateBasketTotal();

    }

    $scope.paymentTempDisabled = checkEuroTransition || isInNeedAttentionStatus;

    $scope.isFormSending = false;
    $scope.isFormSeatsError = false;
    $scope.isFormQuantityRestrictionError = false;
    $scope.quantityRestrictionErrorMessages = [];
    $scope.quantitiesResetAfterUnlock = false;

    $scope.sendForm = function($event) {
        if($scope.paymentTempDisabled){
            $event.preventDefault();
            return false;
        }

        $event.preventDefault();
        $scope.isFormSending = true;

        if ($scope.shopType === "REGULAR") {
            var ticketsTotal = 0;
            $(".ticketQuantity").each(function(index, value) {
                ticketsTotal += parseInt($(value).val());
            });
            if (ticketsTotal === 0) {
                $event.preventDefault();
                $scope.isFormSending = false;
                makeInfoBar(lang.noQuantityError, 'error', 500, 8000);
            } else {
                window.track.addToCart(document.querySelector('.js-track-cart-item-list'), true);
                $("#eventInfoForm").submit();
            }
        } else {
            if ($scope.shoppingBasket.length === 0) {
                $event.preventDefault();
                $scope.isFormSending = false;
                makeInfoBar(lang.noQuantityError, 'error', 500, 8000);
            } else {
                window.track.addToCart(document.querySelector('.js-track-cart-item-list'), false);
                $scope.promoCode = $scope.promoCode ? $scope.promoCode : $scope.promoCodeSeats;
                $scope.$applyAsync();
                $("#eventInfoForm").submit();
            }
        }
    }

    $(".animafest_table .et, .button-animafest[data-id]").click(function(a) {
        a.preventDefault();
        var b = $(this).attr("data-id");
        $("html, body").stop().animate({
            scrollTop: "200px"
        }, 1e3), $("#animafest_tables").stop().slideUp(1200, function() {
            $("#event_time_chooser").hide(), $(".multitime-date[data-event-time-id='" + b + "']").show(), $("#backToEtChooser").show()
        })
    }), $("#backToEtChooser").click(function() {
        $("#event_time_chooser").show(), $(".multitime-date").stop().slideUp(function() {
            $(".multitime-date").hide(), $("#backToEtChooser").hide(),
                $("#animafest_tables").slideDown(1200)
        })
    })


    $scope.removeItemFromShoppingBasket = function(item) { // used with multitimeevents
        var selectedIndex = -1;
        $($scope.shoppingBasket).each(function(index, value) {
            if (value.categoryId === item.categoryId) {
                selectedIndex = index;
            }
        });

        if (selectedIndex != -1) {
            $scope.shoppingBasket.splice(selectedIndex, 1);
        }

        if (!item.isSeats) {
            $scope.ticketCategories[item.timeId].times[item.categoryId].quantity = 0;
        }

        $scope.calculateBasketTotal();
    }

    $scope.baseTotal = 0;
    $scope.baseTotalEur = 0;
    $scope.customerFeeTotal = 0;
    $scope.customerFeeTotalEur = 0;
    $scope.total_fee_quantity = 0;
    $scope.discount = 0;
    $scope.removeSeatFromShoppingBasket = function(cartItem, noDeslect, location) { // used with seats.io
        let id = cartItem.id;
        var selectedIndex = -1;
        $($scope.shoppingBasket).each(function(index, value) {
            if (value.id === id && value.ticketType === cartItem.ticketType)
                selectedIndex = index;

        });
        if (selectedIndex != -1 && !location) { // skip double deselecting from frontend list x click
            $scope.shoppingBasket.splice(selectedIndex, 1)
        }

        $scope.$applyAsync();

        if (noDeslect) {

        } else {
            chart.deselectObjects([{id: id, amount: 1, ticketType: cartItem.ticketType}]);
        }
        $scope.calculateBasketTotal();
        $scope.$applyAsync();
    }

    $scope.openFeeModal = function(){
        setTimeout(function() {
            window.entrio.showModal('#booking_fee_modal')
        }, 1);
    }

    $scope.recalculate_discount = function(){
        //to-do - backend discount recalculation
    }

    $scope.calculateBasketTotal = function() {
        var total = 0;
        var total_customer_fee = 0;
        var total_fee_quantity = 0;
        $($scope.shoppingBasket).each(function(index, value) {
            if (value.quantity === undefined) {
                value.quantity = 1;
            }
            total += (value.price * value.quantity);
            total_customer_fee += (value.bookingFeePrice * value.quantity);
            total_fee_quantity += (value.bookingFeePrice * value.quantity > 0 ? value.quantity : 0);
        });
        $scope.total_fee_quantity = total_fee_quantity;
        $scope.baseTotal = total.toFixed(2);

        $scope.baseTotalEur = (Math.round((total / euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2);
        $scope.customerFeeTotal = total_customer_fee.toFixed(2);
        $scope.customerFeeTotalEur = (Math.round((total_customer_fee / euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2);

        if(!$scope.discount) {
            $scope.discount = 0;
        }

        var fullTotal = $scope.baseTotal - $scope.discount + total_customer_fee;
        if (fullTotal < 0) {
            fullTotal = 0;
        }

        $scope.shoppingBasketTotal = fullTotal.toFixed(2);
        $scope.shoppingBasketTotalEur = (Math.round((fullTotal / euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2);

        if (euro_transition_period.isEurDay) {
            $scope.baseTotalEur = (Math.round((total * euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2);
            $scope.customerFeeTotalEur = (Math.round((total_customer_fee * euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2);
            $scope.shoppingBasketTotalEur = (Math.round((fullTotal * euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2);
        }
        $scope.$applyAsync();
    }

    $scope.toggleDescription = function(categoryId) {
        const parentRow = $(`#${categoryId}`)[0];
        const rowAction = parentRow.querySelector('.event-tickets__column-info-action');
        const descriptionRow = parentRow.nextElementSibling;

        if (descriptionRow && rowAction) {
            if (!descriptionRow.classList.contains('is-shown')) {
                parentRow.classList.add('is-active');
                rowAction.classList.add('is-active');
                descriptionRow.classList.add('is-shown');
            }
        }
    }

    $scope.quantityChange = function(timeId, categoryId, item) {
        var found = false;
        var removeIndex = -1;

        if (item.quantity > 100) {
            item.quantity = 100;
        }

        $($scope.shoppingBasket).each(function(index, value) {
            if (value.categoryId === categoryId) {
                found = true;
                removeIndex = index;
                value.quantity = item.quantity;
            }
        });

        if (!found && item.quantity > 0) {
            var amount_fee = $('#'+categoryId).find('.price-fee .amount-fee').text();
            var booking_fee_price = (amount_fee != "" ? amount_fee : 0);
            let convertedPriceToEur = (Math.round((item.price / euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2);
            let convertedFeeToEur = (Math.round((((item.price != 0 && booking_fee_price) ? booking_fee_price : 0) / euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2);

            if( euro_transition_period.isEurDay) {
                convertedPriceToEur = (Math.round((item.price * euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2);
                convertedFeeToEur = (Math.round((((item.price != 0 && booking_fee_price) ? booking_fee_price : 0) * euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2);
            }

            $scope.shoppingBasket.push({
                price: item.price,
                convertedPriceToEur: convertedPriceToEur,
                convertedFeeToEur: convertedFeeToEur,
                bookingFeePrice: amount_fee != "" ? amount_fee : 0,
                quantity: item.quantity,
                name: $sce.trustAsHtml(item.name),
                categoryId: categoryId,
                timeId: timeId,
                timeDate: item.time_date_string ?? null
            });
        }

        if (item.quantity < 1 && found) {
            $scope.shoppingBasket.splice(removeIndex, 1);
        }
        $scope.calculateBasketTotal();
        $scope.toggleDescription(categoryId);
    }

    $scope.increaseQuantity = function(timeId, categoryId, item, min, max, step) {
        var found = false;
        item.quantity += step;

        if (item.quantity > max) {
            item.quantity = max;
        }

        if (item.quantity < min) {
            item.quantity = min;
        }

        $($scope.shoppingBasket).each(function(index, value) {
            if (value.categoryId === categoryId) {
                found = true;
                value.quantity = item.quantity;
            }
        });

        if (!found) {
            var amount_fee = $('#'+categoryId).find('.price-fee .amount-fee').text();
            var booking_fee_price = (amount_fee != "" ? amount_fee : 0);
            let convertedPriceToEur = (Math.round((item.price / euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2);
            let convertedFeeToEur = (Math.round((((item.price != 0 && booking_fee_price) ? booking_fee_price : 0) / euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2);

            if (euro_transition_period.isEurDay) {
                convertedPriceToEur = (Math.round((item.price * euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2);
                convertedFeeToEur = (Math.round((((item.price != 0 && booking_fee_price) ? booking_fee_price : 0) * euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2);
            }

            $scope.shoppingBasket.push({
                label: 'nonSeatObject',
                price: item.price,
                convertedPriceToEur: convertedPriceToEur,
                convertedFeeToEur: convertedFeeToEur,
                bookingFeePrice: amount_fee != "" ? amount_fee : 0,
                quantity: item.quantity,
                name: $sce.trustAsHtml(item.name),
                categoryId: categoryId,
                timeId: timeId,
                timeDate: item.time_date_string ?? null,
                isSeats: false
            });
        }
        $scope.calculateBasketTotal();
        $scope.toggleDescription(categoryId);
    }

    $scope.reduceQuantity = function(timeId, categoryId, item, min, max, step) {
        if (item.quantity <= 0) {
            return;
        }

        item.quantity -= step;
        var removeIndex = -1;
        $($scope.shoppingBasket).each(function(index, value) {
            if (value.categoryId === categoryId) {

                value.quantity = item.quantity;
                if (item.quantity === 0) {
                    removeIndex = index;
                }
            }
        });

        if (removeIndex !== -1) {
            $scope.shoppingBasket.splice(removeIndex, 1);
        }

        $scope.calculateBasketTotal();
        $scope.toggleDescription(categoryId);
    }

    $scope.timeEventsTemplate = '';

    const addQueryParam = (key, value) => {
        const url = new URL(window.location.href);
        url.searchParams.set(key, value);
        window.history.pushState({}, '', url.toString());
    };

    const removeQueryParam = (key, value) => {
        const url = new URL(window.location.href);
        url.searchParams.delete(key, value);
        window.history.pushState({}, '', url.toString());
    };

    const getQueryParam = (key) => {
        const url = new URL(window.location.href);
        return url.searchParams.get(key) || '';
    };

    $scope.loadTicketsAjax = function(timeId, checkDates = true) {
        if (!$("#ticketsList" + timeId).length && checkDates) {
            if (typeof etDates === 'undefined' || !etDates) {
                return;
            }

            const slot = etDates.find(i => String(i.et_id) === String(timeId));

            if (!slot) {
                return;
            }

            window.getEventTimes({
                eventTimeId: slot.et_id,
                eventId: slot.event_id,
                appType: globalAppType,
                dateStr: slot.start,
            }, true);

            return;
        }

        $scope[`isLoading_${timeId}`] = true;
        $scope.$applyAsync();

        var promoCode = $scope.promoCode ? $scope.promoCode : getQueryParam('pc');

        $.ajax({
            url: siteUrl + "ajax/get_event_time_categories",
            data: {
                timeId: timeId,
                promoCode: promoCode,
            },
            type: "POST",
            dataType: "json",
        }).done(function(data) {
            var html = $("#ticketsList" + timeId);
            $scope.ticketCategories[timeId] = {visible: true, times: {}};

            html.html(data.html);

            $compile(html.contents())($scope);

            if(data.is_seats_page){
                $scope.generateSeatsChart(timeId);
            }

            $scope[`isLoading_${timeId}`] = false;
            $scope.$applyAsync();
        });
    }

    if (getQueryParam('timeSlot')) {
        $scope.loadTicketsAjax(getQueryParam('timeSlot'))
    }

    $scope.loadTickets = function(timeId) {
        if (Number(getQueryParam('timeSlot')) === Number(timeId)) {
            removeQueryParam('timeSlot', timeId)
        } else {
            addQueryParam('timeSlot', timeId)
        }

        for (const [key, value] of Object.entries($scope.ticketCategories)) {
            if (Number(key) !== Number(timeId)) {
                $scope.ticketCategories[key].visible = false;
            }
        }

        if ($scope.ticketCategories[timeId]) { // this category was already loaded so we just need to toggle it
            $scope.ticketCategories[timeId].visible = !$scope.ticketCategories[timeId].visible;
            $scope.$applyAsync();
            return;
        }

        $scope.loadTicketsAjax(timeId)
    }

    document.querySelectorAll('.js-time-single-event').forEach(el => {
        el.addEventListener('click', event => {
            const matchMediaMedium = window.matchMedia(`screen and (min-width: 768px)`);
            const timeId = el.dataset?.eventTimeId;

            if (!matchMediaMedium.matches && timeId) {
                $scope.loadTickets(timeId);
                $scope.$apply;
            }
        })
    })

    function calculateTicketPrices() {
        var totalTicketPrice = 0;
        var totalTicketPriceConversion = 0;
        var totalTicketFeePrice = 0;
        var totalTicketCategoryPrice = 0;
        var totalTicketQuantity = 0;

        if (!$scope.discountedTicketsCount) {
            $scope.discountedTicketsCount = 0;
        }

        $('.ticketPurchaseModel').each(function() {
            var price = $(this).find('.price .amount').text();
            var price_fee = $(this).find('.price-fee .amount-fee').text();
            price = isNaN(price) ? 0 : price;
            price_fee = isNaN(price_fee) ? 0 : price_fee;

            var quantity = $(this).find('.ticketQuantity').attr('value');
            quantity = typeof (quantity) !== 'undefined' ? quantity : 0;
            totalTicketQuantity = totalTicketQuantity + (price_fee !== 0 ? parseInt(quantity) : 0);
            $scope.totalTicketQuantity = totalTicketQuantity;
            totalTicketFeePrice = totalTicketFeePrice + (price_fee * quantity);
            totalTicketCategoryPrice = totalTicketCategoryPrice + (price * quantity);
            totalTicketPrice = totalTicketPrice + (price * quantity) + (price_fee * quantity);
        });

        $('.js-total-price .amount').html(totalTicketPrice.toFixed(2));

        if (euro_transition_period.isEurDay) {
            $('.js-conversion-total-eur .amount-transition').html((Math.round((totalTicketPrice * euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2));
        } else {
            $('.js-conversion-total-eur .amount-transition').html((Math.round((totalTicketPrice / euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2));
        }

        $('.js-total-tickets-price .amount_per_ticket').html(totalTicketFeePrice < 0 ? (0).toFixed(2) : totalTicketFeePrice.toFixed(2));

        if (euro_transition_period.isEurDay) {
            $('.js-total-tickets-price .amount_per_ticket_eur').html(totalTicketFeePrice < 0 ? (0).toFixed(2) : (Math.round((totalTicketFeePrice * euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2));
            $('.js-total-tickets-price .amount_ticket_eur').html(totalTicketCategoryPrice < 0 ? (0).toFixed(2) : (Math.round((totalTicketCategoryPrice * euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2));

        } else {
            $('.js-total-tickets-price .amount_per_ticket_eur').html(totalTicketFeePrice < 0 ? (0).toFixed(2) : (Math.round((totalTicketFeePrice / euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2));
            $('.js-total-tickets-price .amount_ticket_eur').html(totalTicketCategoryPrice < 0 ? (0).toFixed(2) : (Math.round((totalTicketCategoryPrice / euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2));
        }

        $('.js-total-tickets-price .amount_ticket').html(totalTicketCategoryPrice < 0 ? (0).toFixed(2) : totalTicketCategoryPrice.toFixed(2));

        let amountTicketQuantity = $scope.totalTicketQuantity - $scope.discountedTicketsCount;

        if (amountTicketQuantity < 0) {
            amountTicketQuantity = 0;
        }

        $('.js-total-tickets-price .amount_ticket_quantity').html(amountTicketQuantity);
    }

    $(function() {
       $('.questionmark').click(function(){
            setTimeout(function() {
               window.entrio.showModal('#booking_fee_modal')
            }, 1);
        });
    });


    if( typeof shopType !== 'undefined' ){
        $scope.shopType = shopType;
    }else{
        $scope.shopType = "";
    }

    $scope.promoCodeMessage = "";
    $scope.promoCodeLoading = false;
    $scope.discountStatus = false;
    $scope.seatsUnlockUsed = false;
    $scope.showPromoCodeInfo = false;

    $scope.promoCode = "";
    if (window.promoCode !== undefined && window.promoCode !== null)
        $scope.promoCode = window.promoCode;


    $scope.sendPromo = function(e) {
        if ($scope.promoCode === "") {
            return;
        }
        caluclate_order(!0);
    }

    $scope.enterPress = function(keyEvent) {
        if (keyEvent.which === 13) {
            keyEvent.preventDefault();
            if($scope.shopType !== "SEATS") {
                $scope.sendPromo();
            }

        if(eventIsMultitime) {
            let url = new URL(window.location.href);
            url.searchParams.set("pc", $scope.promoCode);
            window.location.href = url.toString();
            }
        }
    }

    $scope.$watch('promoCode', function(){
        if($scope.shopType === "SEATS"){
            if($scope.promoCode && $scope.promoCode.length > 0){
                $scope.showPromoCodeInfo = true;
            }else{
                $scope.showPromoCodeInfo = false;
            }
            $scope.$applyAsync();
        }

        if(eventIsMultitime){
            $scope.showPromoCodeInfo = true;
            $scope.$applyAsync();
        }
    });

    var delayTimer;
    var xhRequest; //ajax post request, important for canceling mid-ajax request
    function caluclate_order(manualDiscount) {
        if (xhRequest && xhRequest.readyState != 4) {
            window.manualRequestAbort = true;
            xhRequest.abort();
        }

        if (manualDiscount) {
            sendPostData(manualDiscount);
        } else {
            clearTimeout(delayTimer);
            delayTimer = setTimeout(function() {
                sendPostData(manualDiscount);
            }, 800);
        }
    }

    function ellipsize_text(text, count, insertDots = true){
        return text.slice(0, count) + (((text.length > count) && insertDots) ? "..." : "");
    }


    function sendPostData(manualPromo) {
        if (manualPromo) {
            var data = $("#eventInfoForm").serialize() + "&manual_promo=true";
        } else {
            var data = $("#eventInfoForm").serialize();
        }

        $scope.promoCodeLoading = true;
        xhRequest = $.post(siteUrl + "shop/reserve_order_by_ajax", data, function(feedback) {
            if($scope.shopType === "SEATS" && feedback.promo_type == 'unlock' && feedback.unlocked_categories_seats.length){
                $(feedback.unlocked_categories_seats).each(function (index, unlocked_category) {
                    var seating_chart_pricing = JSON.parse(unlocked_category.seating_chart_pricing_string);
                    var seating_chart_quantity = JSON.parse(unlocked_category.seating_chart_quantity_string);
                    var category_restrictions_lang = JSON.parse(unlocked_category.categoryRestrictionsLang);
                    //pricing.push(seating_chart_pricing);
                    maxObjects.push(seating_chart_quantity);
                    categoryRestrictionsLang.push(category_restrictions_lang);

                    let inserted = false;
                    pricing.forEach(function (data, index, object) {
                        if(data.category === seating_chart_pricing.category){
                            seating_chart_pricing.ticketTypes.forEach(function (unlocked) {
                                data.ticketTypes.push(unlocked);
                                inserted = true;
                            });
                        }
                    });

                    if(!inserted){
                        pricing.push(seating_chart_pricing);
                    }
                });

                if ($(window).width() < 760) {
                    $(pricing).each(function(key, ticket_cat) {
                        $(ticket_cat.ticketTypes).each(function(key2, ticketType) {
                            ticketType.description = ellipsize_text(ticketType.description, 160)
                        });
                    });
                }

                chart.changeConfig({
                    maxSelectedObjects: maxObjects,
                    pricing: pricing,
                });
                chart.rerender();

                $scope.promoCodeSeats = angular.copy($scope.promoCode);
                $('#hiddenUnlockCode').val($scope.promoCodeSeats);
                $scope.promoCode = "";
                $scope.seatsUnlockUsed = true;
                $scope.$applyAsync();
            }

            var result = feedback;

            if (feedback.promo_error_message !== undefined) {
                $scope.promoCodeMessage = feedback.promo_error_message;
                $scope.discountValid = false;
            } else if (feedback.promo_success_message !== undefined) {
                $scope.promoCodeMessage = feedback.promo_success_message;
                $scope.discountValid = true;
            } else {
                if (feedback.error_messages !== undefined && feedback.error_messages.length > 0) {
                    $scope.promoCodeMessage = feedback.error_messages[0];
                }
                $scope.discountValid = false;
            }

            if (feedback.promo_error_message_show) {
                $scope.promoCodeMessage = lang.promoCodeErrorMessage;
                $scope.discountValid = false;
                $scope.truncatePromoErrorMessage = true;
            } else {
                $scope.truncatePromoErrorMessage = false;
            }

            $scope.discount_fee = 0;
            $scope.discount_price = 0;

            if ($(".ticketPurchaseModel").find(".discountFeedback").hasClass("is-hidden") === false) {
                $(".ticketPurchaseModel").find(".discountFeedback").text("").addClass("is-hidden");
            }

            if (feedback.hasOwnProperty('ticket_time_category_messages') && feedback.ticket_time_category_messages) {
                for (var c in feedback.ticket_time_category_messages) {
                    $(".ticketPurchaseModel#" + c).find(".discountFeedback").html(feedback.ticket_time_category_messages[c]).removeClass("is-hidden");
                    if(feedback.ticket_time_category_messages[c].indexOf('100%') !== -1){
                        var lastNum = feedback.ticket_time_category_messages[c].replace(/.*?(\d+)[^\d]*$/,'$1');
                        $scope.discount_fee = $scope.discount_fee + Number($(".ticketPurchaseModel#" + c).find(".amount-fee").text()) * lastNum;
                        $scope.discount_price = $scope.discount_price + Number($(".ticketPurchaseModel#" + c).find(".price .amount").text()) * lastNum;
                    }
                }
            }

            if (document.querySelectorAll('.ticketPurchaseModel').length) {
                document.querySelectorAll('.ticketPurchaseModel').forEach((item) => {
                    if (item.hasAttribute('data-discount-name')) {
                        item.removeAttribute('data-discount-name')
                    }
                    if (item.hasAttribute('data-discount-per-ticket')) {
                        item.removeAttribute('data-discount-per-ticket')
                    }
                    if (item.hasAttribute('data-discount-count')) {
                        item.removeAttribute('data-discount-count')
                    }
                })
            }

            if (feedback.hasOwnProperty('ticket_time_category_promo') && feedback.ticket_time_category_promo) {
                for (var c in feedback.ticket_time_category_promo) {
                    document.getElementById(`${c}`).dataset.discountName = feedback.ticket_time_category_promo[c];
                }
            }

            if (feedback.hasOwnProperty('ticket_time_category_values') && feedback.ticket_time_category_values) {
                for (var c in feedback.ticket_time_category_values) {
                    document.getElementById(`${c}`).dataset.discountPerTicket = feedback.ticket_time_category_values[c];
                }
            }
            var discountedTicketsCount = 0;
            if (feedback.hasOwnProperty('total_time_category_discount_counts') && feedback.total_time_category_discount_counts) {
                for (var c in feedback.total_time_category_discount_counts) {
                    document.getElementById(`${c}`).dataset.discountCount = feedback.total_time_category_discount_counts[c];
                    discountedTicketsCount += feedback.total_time_category_discount_counts[c];
                }
            }
            $scope.discountedTicketsCount = discountedTicketsCount;

            $scope.totalDiscount = feedback.total_discount_value;

            let amount_per_ticket = (Number($('.js-total-tickets-price .amount_per_ticket').text()) - $scope.discount_fee);
            let amount_ticket = (Number($('.js-total-tickets-price .amount_ticket').text()) - $scope.discount_price);
            $('.js-total-tickets-price .amount_per_ticket').text(amount_per_ticket < 0 ? (0).toFixed(2) : amount_per_ticket.toFixed(2));
            if(euro_transition_period.isEurDay){
                $('.js-total-tickets-price .amount_per_ticket_eur').text(amount_per_ticket < 0 ? (0).toFixed(2) : (Math.round((amount_per_ticket * euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2));
                $('.js-total-tickets-price .amount_ticket_eur').text(amount_ticket < 0 ? (0).toFixed(2) : (Math.round((amount_ticket * euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2));
            }else{
                $('.js-total-tickets-price .amount_per_ticket_eur').text(amount_per_ticket < 0 ? (0).toFixed(2) : (Math.round((amount_per_ticket / euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2));
                $('.js-total-tickets-price .amount_ticket_eur').text(amount_ticket < 0 ? (0).toFixed(2) : (Math.round((amount_ticket / euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2));
            }

            $('.js-total-tickets-price .amount_ticket').text(amount_ticket < 0 ? (0).toFixed(2) : amount_ticket.toFixed(2));
            $('.js-total-tickets-price .amount_ticket_quantity').html($scope.totalTicketQuantity - $scope.discountedTicketsCount);

            var quantity = $(this).find('.ticketQuantity').attr('value');
            if($scope.totalDiscount > 0 && ($scope.discount_price === 0)){
                $('.js-total-tickets-price .amount_ticket').text(amount_ticket < 0 ? (0).toFixed(2) : amount_ticket.toFixed(2));
                $('.js-total-tickets-price .amount_ticket_eur').text(amount_ticket < 0 ? (0).toFixed(2) : (Math.round((amount_ticket / euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2));

                if(euro_transition_period.isEurDay){
                    $('.js-total-tickets-price .amount_ticket_eur').text(amount_ticket < 0 ? (0).toFixed(2) : (Math.round((amount_ticket * euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2));
                }
            }

            if (manualPromo && typeof feedback.promo_success_message !== 'undefined') {
                if (feedback.promo_type === "discount") {
                    $("#hiddenDiscountCode").val($("#promocode").val());
                }
            }

            if (feedback.promo_type === "unlock") {
                var last_unlock_id = null;
                $(feedback.unlocked_categories).each(function(index, value) {
                    var id = $(value).attr('id');
                    last_unlock_id = id;

                    if($(".ticketPurchaseModel[id='" + id + "']").length === 0) {
                        $(".js-total-tickets-price").before(value);

                        const table = document.createElement("table");
                        const tableBody = document.createElement("tbody");
                        const items = document.querySelectorAll('.js-track-item');
                        const lastItem = items[items.length - 1];
                        lastItem.dataset.index = items.length - 1;

                        tableBody.appendChild(lastItem.cloneNode());
                        table.appendChild(tableBody);
                        window.track.trackViewItem(table);
                    }
                });
                $(".event-tickets--is-hidden").removeClass('event-tickets--is-hidden');
                $(".event-sold-out").hide();

                //Deselect any previously set quantites
                if(!$scope.quantitiesResetAfterUnlock){
                    $(".ticketQuantity").val(0);
                    $(".ticketQuantity").attr("value", 0).trigger("change");
                    $(".ticketQuantity").prop("value", 0).trigger("change");

                    //Set unlocked category quantity to 1 by default if only 1 category unlocked
                    if (feedback.unlocked_categories.length === 1) {
                        $("#"+last_unlock_id).find(".ticketQuantity").val(1);
                        $("#"+last_unlock_id).find(".ticketQuantity").attr("value", 1).trigger("change");
                        $("#"+last_unlock_id).find(".ticketQuantity").prop("value", 1).trigger("change");
                    }
                }

                $scope.quantitiesResetAfterUnlock = true;
            }

            if (feedback.total_discount_value != 0 && feedback.total_discount_value != null) {
                $(".ticketDiscountTotal").show().css({display: 'table-row !important'});
                $(".js-total-price .amount").html(feedback.final_price_no_currency);
                $(".totalDiscountPrice").html(feedback.total_discount);
                $(".totalBasePrice").html(feedback.base_price);
                if (euro_transition_period.enabled) {
                    $('.js-conversion-total-eur .amount-transition').html((feedback.final_price_value_eur));
                    $(".totalDiscountPriceEurAmount").html(feedback.total_discount_value_eur);
                    $(".totalBasePriceEurAmount").html(feedback.base_price_value_eur);
                    $(".totalBasePriceCurrency").html(feedback.converted_currency);
                }

            } else {
                $(".ticketDiscountTotal").attr("style", "display: none !important");
                $(".discountFeedback").text("").addClass("is-hidden");
            }

            $scope.discount = feedback.total_discount_value;
            $scope.calculateBasketTotal();
            $scope.promoCodeLoading = false;

            $scope.sendFormDisabled = true;
            $(".ticketQuantity").each(function() {
                if (Number($(this).val()) !== 0) {
                    $scope.sendFormDisabled = false;
                }
            });

            if (Boolean(window.setActionWidth)) {
                window.setActionWidth();
            }

            $scope.$apply();

            $('.js-promocode-error-modal').click(function(){
                setTimeout(function() {
                    window.entrio.showModal('#promocode-error-modal');
                }, 1);
            });
        }, 'json');
    };

    $scope.sendFormDisabled = true;
    if ($('.js-ticket-quantity').length) {
        $('.js-ticket-quantity').each(function() {
            if (Number($(this)[0].value)) {
                $scope.sendFormDisabled = false;
            }
        });
    }

    function changeTicketQuantity() {
        if ($(this).hasClass("ticketQuantity")) {
            var a = $(this);
        } else {
            var a = $(this).siblings(".ticketQuantity");
        }
        var old_val = a.prop("value");
        var restriction_min = parseInt(a.attr("data-quantity-restriction-min"), 10);
        var restriction_max = parseInt(a.attr("data-quantity-restriction-max"), 10);
        var restriction_step = parseInt(a.attr("data-quantity-restriction-step"), 10);

        if(isNaN(old_val) || "" === old_val || /^[0-9]+$/ === old_val){
            old_val = 0;
        }

        var new_val = old_val;
        old_val = parseInt(old_val, 10);
        var modulo = (old_val-restriction_min)%restriction_step;
        if(modulo != 0){
            new_val = old_val+(restriction_step-modulo);
        }
        if(old_val > restriction_max){
            new_val = restriction_max;
        }
        if(old_val < restriction_min){
            new_val = restriction_min;
        }

        if(!$(this).hasClass("buyMoreTickets") || !$(this).hasClass("buyFewerTickets")){
            //reset to 0 after focus out with 0
            if(old_val <= 0){
                new_val = 0;
            }
        }

        if ($(this).hasClass("buyMoreTickets")) {
            if(old_val < restriction_min){
                new_val = restriction_min;
            } else if(old_val + restriction_step <= restriction_max){
                new_val = old_val + restriction_step;
            }
        } else if ($(this).hasClass("buyFewerTickets")) {
            new_val = old_val - restriction_step;
            if(new_val < 0 || new_val < restriction_min){
                new_val = 0;
            }
        }
        new_val = new_val.toString();
        a.attr("value", new_val).trigger("change");
        a.prop("value", new_val).trigger("change");

        if ($scope.promoCode !== "") {
            caluclate_order(1);
        } else if(eventHasAutoDiscount){
            caluclate_order();
        }

        $scope.sendFormDisabled = true;
        $(".ticketQuantity").each(function() {
            if (Number($(this).val()) !== 0) {
                $scope.sendFormDisabled = false;
            }
        });

        $scope.$applyAsync();

        const parentRow = $(this)[0].closest('.event-tickets__table-row');
        const rowAction = parentRow.querySelector('.event-tickets__column-info-action');
        const descriptionRow = parentRow.nextElementSibling;

        if (!descriptionRow.classList.contains('is-shown') && rowAction && Number(new_val)) {
            parentRow.classList.add('is-active');
            rowAction.classList.add('is-active');
            descriptionRow.classList.add('is-shown');
        }
    }

    $(document).on("click", ".buyFewerTickets, .buyMoreTickets", changeTicketQuantity);
    $(document).on('input', ".ticketQuantity", changeTicketQuantity);

    var uri = window.location.search;
    var queryString = {};
    uri.replace(
        new RegExp("([^?=&]+)(=([^&]*))?", "g"),
        function($0, $1, $2, $3) { queryString[$1] = $3; }
    );

    if(queryString['pc'] !== undefined && queryString['pc'] !== null ){
        $scope.promoCode = queryString['pc'];
    }

    if(queryString['select_cat'] !== undefined && queryString['select_cat'] !== null ){
        $scope.selectedCats = queryString['select_cat'].split(", ");
    }

    if(queryString['select_q'] !== undefined && queryString['select_q'] !== null ){
        $scope.selectedQuantites = queryString['select_q'].split(", ");
    }

    setTimeout(function() {
        if(queryString['select_q'] !== undefined && queryString['select_q'] !== null &&
            queryString['select_cat'] !== undefined && queryString['select_cat'] !== null) {
            $($scope.selectedCats).each(function (index, val) {
                $("#" + val + " .ticketQuantity").val($scope.selectedQuantites[index])

            });
            calculateTicketPrices();
        }
        if ($scope.promoCode !== "" && isEventFinished == 0)
            caluclate_order(true); //auto promo code
    }, 500);

    $scope.generateSeatsChart = function(id) {
        var selectionValidators = [];

        if(!disable_orphan_check){
            if (typeof orphan_check_mode === 'undefined') {
                selectionValidators.push({type :'noOrphanSeats'});
            } else {
                selectionValidators.push({type :'noOrphanSeats', mode: orphan_check_mode});
            }
        }

        if ($(window).width() < 760) {
            $(pricing).each(function(key, ticket_cat) {
                $(ticket_cat.ticketTypes).each(function(key2, ticketType) {
                    ticketType.description = ellipsize_text(ticketType.description, 160)
                });
            });
        }

        var isInitialChartRendered = false;

        var chart = new seatsio.SeatingChart({
            language: (typeof entrioLang == "undefined" || entrioLang == null) ? "en" : entrioLang,
            messages: (typeof seatsIoTranslationMessages !== "undefined") ? seatsIoTranslationMessages : {},
            divId: `chart${id ?? ''}`,
            workspaceKey: seatsPublicKey,
            event: seatsEventKey,
            maxSelectedObjects: maxObjects,
            extraConfig: {
                userSeatsOnEvent: userSeatsOnEvent,
                buyMoreSeatsEnabled: buyMoreSeatsEnabled,
                isInitialChartRendered: isInitialChartRendered,
            },
            selectionValidators: selectionValidators,
            multiSelectEnabled: multiSelectEnabled === 1,
            isObjectSelectable: function(parametar, def) {
                // isInitialChartRendered is used because parametar.bookAsAWhole is changed to false in objectColor() in order to be selectable, otherwise seats.io will ignore selection
                if (chart.config.extraConfig.buyMoreSeatsEnabled && chart.config.extraConfig.userSeatsOnEvent.length && (parametar.bookAsAWhole || chart.config.extraConfig.isInitialChartRendered) && chart.config.extraConfig.userSeatsOnEvent.includes(parametar.label) && parametar.numBooked > 0 && parametar.capacity > parametar.numBooked){
                    parametar.minOccupancy = 1;
                    parametar.highlighted = true;
                    parametar.bookAsAWholeHack = true;
                    chart.config.extraConfig.isInitialChartRendered = true;

                    return true;
                }

                if(chart.config.extraConfig.buyMoreSeatsEnabled){
                    return false;
                }

                if (parametar.category !== null && parametar.category.categoryPricing !== undefined && parametar.category.categoryPricing.categoryPricing !== undefined && parametar.category.categoryPricing.categoryPricing.ticketTypes !== undefined && parametar.category.categoryPricing.categoryPricing.ticketTypes.length > 0) {
                    return def;
                }

                return false;
            },
            objectPopover: {
                showAvailability: false,
                showCategory: true,
                showLabel: true,
                showPricing: true,
                showUnavailableNotice: true,
                stylizedLabel: true,
                confirmSelection: 'auto',
                confirmTicketTypeSelection: false
            },
            showActiveSectionTooltipOnMobile: false,
            popoverInfo: function(object) {
                if (object.category === undefined || object.selectable === false || object.status === 'free') {
                    return;
                }

                if (object.objectType === 'section') {
                    let prices = object.selectableCategories.length ? object.selectableCategories[0].pricing.ticketTypes.map(item => item.price) : [];
                    let lowestPrice = Math.min(...prices);
                    let highestPrice = Math.max(...prices);

                    let returnString = `${object.label}[br/]${object.numberOfSelectableObjects} ${seatsIoTranslationMessages["available.seats"]}[br/]`;

                    if (lowestPrice !== highestPrice) {
                        returnString += `From: ${currency(lowestPrice, globalCurrency)}[br/]To: ${currency(highestPrice, globalCurrency)}`;
                    } else {
                        returnString += currency(highestPrice, globalCurrency);
                    }
                    return returnString;
                }
            },
            pricing: pricing,
            priceFormatter: function(price) {
                if (euro_transition_period.enabled) {
                    let currencyCode = 'EUR';
                    let euroConvertedPrice = Math.round((price / euro_transition_period.rate + Number.EPSILON) * 100) / 100;
                    if (euro_transition_period.isEurDay) {
                        currencyCode = 'HRK';
                        euroConvertedPrice = Math.round((price * euro_transition_period.rate + Number.EPSILON) * 100) / 100;
                    }
                    return currency(price, globalCurrency) + ' (' + euroConvertedPrice + ' ' + currencyCode + ')';
                }
                return currency(price, globalCurrency);
            },
            objectColor: function(object) {
                if(chart.config.extraConfig.userSeatsOnEvent.length && object.bookAsAWholeHack && chart.config.extraConfig.userSeatsOnEvent.includes(object.label) && object.numBooked > 0 && object.capacity > object.numBooked){
                    object.bookAsAWhole = false;
                    return "#72B3CF ";
                }
            },
            onObjectSelected: function(object, selectedTicketType) {
                let convertedPriceToEur = (Math.round((selectedTicketType.price / euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2);
                let convertedFeeToEur = (Math.round((((selectedTicketType.price != 0 && selectedTicketType.feePayorType == 1) ? selectedTicketType.bookingFeePrice : 0) / euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2);
                if (euro_transition_period.isEurDay) {
                    convertedPriceToEur = (Math.round((selectedTicketType.price * euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2);
                    convertedFeeToEur = (Math.round((((selectedTicketType.price != 0 && selectedTicketType.feePayorType == 1) ? selectedTicketType.bookingFeePrice : 0) * euro_transition_period.rate + Number.EPSILON) * 100) / 100).toFixed(2);
                }

                $scope.addToShoppingBasket({
                    label: object.label,
                    ticketType: selectedTicketType.ticketType,
                    price: selectedTicketType.price,
                    convertedPriceToEur: convertedPriceToEur,
                    convertedFeeToEur: convertedFeeToEur,
                    bookingFeePrice: (selectedTicketType.price != 0) && (selectedTicketType.feePayorType == 1) ? selectedTicketType.bookingFeePrice : 0,
                    id: object.id,
                    ticketCategory: selectedTicketType.eventTicketCategory,
                    timeDate: selectedTicketType.timeDateString ?? null,
                    timeSlotName: selectedTicketType.timeSlotName ?? null,
                    isSeats: true
                });

                $scope.updateQuantityRestrictions();

                $scope.$applyAsync();
            },
            onObjectDeselected: function(object, deselectedTicketType) {
                deselectedTicketType.id = object.id;
                $scope.removeSeatFromShoppingBasket(deselectedTicketType, true);
                $scope.updateQuantityRestrictions();
                $scope.$applyAsync();
            },
            onSelectionInvalid: function() {
                $scope.isFormSeatsError = true;
                makeInfoBar(lang.seats_no_orphan_seats, 'warning', 500, 8000);
                $scope.$applyAsync();
            },
            onSelectionValid: function() {
                $scope.isFormSeatsError = false;
                $scope.$applyAsync();
            }
        }).render();

        return chart;
    }

    if ($scope.shopType === "SEATS") {
        var chart = $scope.generateSeatsChart();
    }

    $scope.updateQuantityRestrictions = function(){
        $scope.groupedBasket = [];
        $scope.shoppingBasket.forEach(function (selectedTicket) {
            const index = $scope.groupedBasket.findIndex(x => x.ticketType === selectedTicket.ticketType);
            if(index === -1){
                $scope.groupedBasket.push(
                    {
                        ticketType: selectedTicket.ticketType,
                        category_id: selectedTicket.ticketCategory,
                        count: 1,
                    }
                )
            }else{
                $scope.groupedBasket[index].count++;
            }
            $scope.$applyAsync();
        });

        if($scope.groupedBasket.length === 0){
            $scope.quantityRestrictionErrorMessages = [];
            $scope.isFormQuantityRestrictionError = false;
            $scope.$applyAsync();
        }

        $scope.groupedBasket.forEach(function (group) {
            maxObjects.forEach(function (definedTicekt) {
                if(definedTicekt.ticketType === group.ticketType){
                    let indexMessage = categoryRestrictionsLang.findIndex(x => x.ticketCategory === group.ticketType);
                    //const  index = $scope.quantityRestrictionErrorMessages.indexOf(categoryRestrictionsLang[indexMessage].lang);
                    let index = $scope.quantityRestrictionErrorMessages.findIndex(x => x.ticketCategory === group.ticketType);
                    if (!buyMoreSeatsEnabled && ((group.count > 0 && group.count < definedTicekt.min) || (group.count % definedTicekt.step !== 0))) {
                        if(index === -1){
                            $scope.quantityRestrictionErrorMessages.push(categoryRestrictionsLang[indexMessage]);
                        }
                    }else{
                        if(index !== -1){
                            $scope.quantityRestrictionErrorMessages.splice(index, 1);
                        }

                    }
                    $scope.$applyAsync();
                }
            });
        });

        $scope.quantityRestrictionErrorMessages.forEach(function (errorMessage,index, object) {
            let found = $scope.groupedBasket.some(el => el.category_id === errorMessage.category_id);
            if(!found){
                object.splice(index, 1);
            }
            $scope.$applyAsync();
        });

        if($scope.quantityRestrictionErrorMessages.length){
            $scope.isFormQuantityRestrictionError = true;
        }else{
            $scope.isFormQuantityRestrictionError = false;
        }
        $scope.$applyAsync();
    }

    $("body").on('change', '.ticketQuantity', function() {
        calculateTicketPrices();
    });
    $("body").on('blur', '.ticketQuantity', function() {
        if ($scope.promoCode !== "") {
            caluclate_order(1);
        }
    });
    calculateTicketPrices();

}]);

window.entrio.entrioApp.controller('userProfileController', ['$scope', '$rootScope', function($scope, $rootScope) {
    $scope.deleteModel = {
        check : ""
    };

    $scope.checkFormLoading = false;

    $scope.processCheckForm = function(form, e){
        if($scope.checkFormLoading){
            e.preventDefault();
            return;
        }


        form.$setSubmitted(true);

        if (form.$invalid) {
            $scope.checkFormLoading = false;
            e.preventDefault();
            return false;
        }

        $scope.checkFormLoading = true;
        return true;
    }

    $scope.deleteDataModalShown = false;

    $scope.m = function(){
        $scope.deleteDataModalShown = false;
    }

    $scope.processingPassword = false;
    $scope.passwordChangeModel = {
        oldPassword: "",
        password: "",
        repeatPassword: "",
    };

    $scope.changePassword = function(){
        $scope.changePasswordForm.$setSubmitted(true);

        if ($scope.changePasswordForm.$invalid) {
            return false;
        }

        $scope.processingPassword = true;
        $.ajax({
            url:    baseUrl + 'auth/password_change_ajax',
            type: "POST",
            data:{
                "old_password": $scope.passwordChangeModel.oldPassword,
                "password": $scope.passwordChangeModel.password,
                "password_confirm": $scope.passwordChangeModel.repeatPassword
            }
        }).then(function(data){
            $scope.processingPassword = false;
            $scope.$apply();
            data = JSON.parse(data);
            makeInfoBar(data.message, detect_notification_severity(data), 500, 8000);
        });
    }

    $scope.setupTimezoneList = function(){
        const guessTimezone = moment.tz.guess();
        let userDBtimezone = false;

        document.querySelector("#newTimezoneOffset").innerHTML = moment.tz.names()
            .reduce((memo, tz) => {
                memo.push({
                    name: tz,
                    offset: moment.tz(tz).utcOffset()
                });

                return memo;
            }, [])
            .sort((a, b) => {
                return a.offset - b.offset
            })
            .reduce((memo, tz) => {
                const timezone = tz.offset ? moment.tz(tz.name).format('Z') : '';
                let selected = '';
                if(UserTimezoneProfile === tz.name){
                    userDBtimezone = true;
                    $('#newTimezoneOffset option:selected').remove();
                    selected = 'selected'
                    $('#newTimezoneName').val(tz.name);
                }
                if(!userDBtimezone && guessTimezone === tz.name){
                    selected = 'selected'
                    $('#newTimezoneName').val(tz.name);
                }
                return memo.concat(`<option data-timezone-name="${tz.name.replace(/_/g, '\n')}" value="${tz.offset}" ${selected}>(GMT${timezone}) ${tz.name.replace(/_/g, '\n')}</option>`);
            }, "");
    }

    $('#newTimezoneOffset').on('change', function() {
        $("#newTimezoneName").val($(this).find(':selected').data('timezone-name'));
    });

    $scope.setupTimezoneList();
}]);

window.entrio.entrioApp.controller('ticketsPaymentController', ['$scope', '$rootScope', '$timeout',  function($scope, $rootScope, $timeout) {
    $scope.place = userdata.city;
    $scope.BuyerCountryShort = userdata.country;
    $scope.refundPhone = userdata.phone;

    $scope.place_bill = billdata.city;
    $scope.bill_address = billdata.bill_address;
    $scope.BillCountryShort = billdata.country;

    $scope.CCAddress = CCData.address;
    $scope.CCPost = CCData.post;
    $scope.CCCity = CCData.city;

    $scope.noAddress = false;

    $scope.insuranceType = "";
    $scope.order_delivery = "";

    //adding cities from iso_cities table
    $scope.myPlaces = [];

    $scope.currentRecalculateRequest = null;

    $scope.paymentMethods = paymentMethods;
    setTimeout(function() {
        if (!$scope.paymentMethods.length) {
            $scope.paymentMethods = paymentMethods;
            $scope.$apply();
        }
    }, 200);

    function buildGooglePlacesResult(config) {
        return {
            formatted_address: config.address.suburb + ', ' + config.address.state,
            address_components: [
                {
                    long_name: config.address.street,
                    short_name : config.address.street,
                    types: [ 'route' ]
                },
                {
                    long_name: config.address.suburb,
                    short_name: config.address.suburb,
                    types: [ 'locality' ]
                },
                {
                    long_name: config.address.state,
                    short_name: config.address.state,
                    types: [ 'country' ]
                }
            ],
            geometry: {
                location: {
                    lat: function () { return config.location.latitude },
                    lng: function () { return config.location.longitude }
                }
            }
        };
    }


    $scope.autocompleteOptions = {
        types: ['(cities)'],
        //componentRestrictions: {country: "hr"}
    };

    $scope.autocompleteOptionsAddress = {
        types: ['address'],
    };

    $scope.empty_autocomplete_data = function(){
        return {
            BuyerCountryShort: null,
            BuyerCountryLong: null,
            BuyerCityShort: null,
            BuyerCityLong: null,
            BuyerCityPostalCode: null,
            CityRouteLong: null,
            CityRouteShort: null,
            neighborhoodLong: null,
            neighborhoodShort: null,
            CityStreetNLong: null,
            CityStreetNShort: null,
            PointofInterestL: null,
            PointofInterestS: null,

        };

    }

    $scope.autocompletePlaces = function(place, autocompleteData){
        for (var i = 0; i < place.address_components.length; i++) {

            switch(place.address_components[i].types[0]){
                case 'country':
                    autocompleteData.BuyerCountryShort = place.address_components[i].short_name;
                    autocompleteData.BuyerCountryLong = place.address_components[i].long_name;
                    break;
                case 'locality':
                    autocompleteData.BuyerCityShort = place.address_components[i].short_name;
                    autocompleteData.BuyerCityLong = place.address_components[i].long_name;
                    break;
                case 'postal_code':
                    autocompleteData.BuyerCityPostalCode = place.address_components[i].short_name;
                    break;
                case 'neighborhood':
                    autocompleteData.neighborhoodLong = place.address_components[i].long_name;
                    autocompleteData.neighborhoodShort = place.address_components[i].short_name;
                    break;
                case 'route':
                    autocompleteData.CityRouteLong = place.address_components[i].long_name;
                    autocompleteData.CityRouteShort = place.address_components[i].short_name;
                    break;
                case 'street_number':
                    autocompleteData.CityStreetNLong = place.address_components[i].long_name;
                    autocompleteData.CityStreetNShort = place.address_components[i].short_name;
                    break;
                case 'point_of_interest':
                    autocompleteData.PointofInterestL = place.address_components[i].long_name;
                    autocompleteData.PointofInterestS = place.address_components[i].short_name;
                    break;
                case 'postal_town':
                    if(!autocompleteData.CityShort) autocompleteData.BuyerCityShort = place.address_components[i].short_name;
                    if(!autocompleteData.CityLong) autocompleteData.BuyerCityLong = place.address_components[i].long_name;
                    break;
                case 'sublocality_level_1':
                case 'sublocality':
                    if(!autocompleteData.CityShort) autocompleteData.BuyerCityShort = place.address_components[i].short_name;
                    if(!autocompleteData.CityLong) autocompleteData.BuyerCityLong = place.address_components[i].long_name;
                    break;
                default:
                    break;
            }
            $scope.$apply();
        }
        return autocompleteData;
    }

    var initialized_address = false;
    $scope.getAddress = function(){
        if(typeof $scope.CCAddress!= "object" || !$scope.CCAddress){
            $scope.BuyerCityShort = $('#BuyerCity').val();
            $scope.BuyerCityLong = $('#BuyerCity').val();
            $scope.BuyerLatitude = $("[name='latitude']").val();
            $scope.BuyerLongitude = $("[name='longitude']").val();
            if(initialized_address == false){
                $timeout(function(){
                    initialized_address = true;
                    $scope.BuyerCountryShort = null;
                    $scope.BuyerCountryShort = userdata.country;
                    $scope.BuyerCountryLong = $('#BuyerCountry option:selected').text();
                });
            }
            return;
        }
        $scope.BuyerCountryShort = null;
        $scope.autocompleteDataAddress = $scope.empty_autocomplete_data();
        $scope.autocompleteDataAddress  = $scope.autocompletePlaces($scope.CCAddress, $scope.autocompleteDataAddress);

        $scope.address = [];
        if($scope.autocompleteDataAddress.PointofInterestL || $scope.autocompleteDataAddress.PointofInterestS){
            $scope.address.push($scope.autocompleteDataAddress.PointofInterestL);
        }else{
            $scope.address.push($scope.autocompleteDataAddress.CityRouteLong, $scope.autocompleteDataAddress.neighborhoodLong, $scope.autocompleteDataAddress.CityStreetNLong);
        }

        $scope.address = $scope.address.filter(function (el) {
            return el;
        });

        if($scope.address.length === 0){
            $scope.address.push($scope.autocompleteDataAddress.BuyerCityLong);
        }

        $('#CCAddress').blur();
        $('#CCAddress').val($scope.address.join(' '));

        $scope.CCPost = $scope.autocompleteDataAddress.BuyerCityPostalCode;
        $scope.BuyerCity = $scope.autocompleteDataAddress.BuyerCityLong;
        $scope.BuyerCityLong = $scope.autocompleteDataAddress.BuyerCityLong;

        $scope.BuyerLatitude = $scope.CCAddress.geometry.location.lat();
        $scope.BuyerLongitude = $scope.CCAddress.geometry.location.lng();

        $scope.BuyerCountryShort = $scope.autocompleteDataAddress.BuyerCountryShort;
        $scope.BuyerCountryLong = $scope.autocompleteDataAddress.BuyerCountryLong;

        $('#BuyerCity').blur();
        $("#BuyerCity").val($scope.autocompleteDataAddress.BuyerCityLong);
        $scope.place = $scope.autocompleteDataAddress.BuyerCityLong;

        $scope.$apply();
    };


    $scope.getCityCountry = function(){
        $scope.BuyerCityShort = null;
        $scope.BuyerCityLong = null;
        $scope.BuyerLatitude = null;
        $scope.BuyerLongitude = null;

        if(typeof $scope.place!= "object" || !$scope.place){
            $scope.BuyerCityShort = $scope.place;
            $scope.BuyerCityLong = $scope.place;
            $scope.BuyerLatitude = null;
            $scope.BuyerLongitude = null;
            if(initialized_address == false){
                initialized_address = true;
                $timeout(function(){
                    $scope.BuyerCountryShort = null;
                    $scope.BuyerCountryLong = null;
                    $scope.BuyerCountryShort = userdata.country;
                    $scope.BuyerCountryLong = $('#BuyerCountry option:selected').text();
                });
                $("[name='city']").val($scope.place);
            }
            return;
        }
        $scope.BuyerCountryShort = null;
        $scope.BuyerCountryLong = null;
        $scope.autocompleteData = $scope.empty_autocomplete_data();
        $scope.autocompleteData  = $scope.autocompletePlaces($scope.place, $scope.autocompleteData);

        $scope.BuyerCountryShort = $scope.autocompleteData.BuyerCountryShort;
        $scope.BuyerCountryLong = $scope.autocompleteData.BuyerCountryLong;
        $scope.BuyerCityLong = $scope.autocompleteData.BuyerCityLong;

        $scope.BuyerLatitude = $scope.place.geometry.location.lat();
        $scope.BuyerLongitude = $scope.place.geometry.location.lng();

        $scope.BuyerCity = $scope.place.formatted_address.split(',')[0].replace(/\s/g, "");
        $scope.BuyerCountry = $scope.place.formatted_address.split(',')[1].replace(/\s/g, "");
        $('#BuyerCity').blur();
        $("#BuyerCity").val($scope.BuyerCityLong);
        $scope.$apply();
    };

    /**/
    var initalize_bill_city = false;
    $scope.getBillCityCountry = function(place_bill){
        $scope.place_bill = place_bill;
        $scope.BillCityShort = null;
        $scope.BillCityLong = null;

        if(typeof $scope.place_bill!= "object" || !$scope.place_bill){
            $scope.BillCityShort = $scope.place_bill;
            $scope.BillCityLong = $scope.place_bill;
            $scope.BillLatitude = $("[name='bill_latitude']").val();;
            $scope.BillLongitude = $("[name='bill_longitude']").val();;
            if(initalize_bill_city == false){
                initalize_bill_city = true;
                $scope.BillCountryShort = null;
                $scope.BillCountryLong = null;
                $timeout(function(){
                    $scope.BillCountryShort = billdata.country;
                    $scope.BillCountryLong = $('#bill_country option:selected').text();
                });
            }
            return;
        }

        $scope.BillCountryShort = null;
        $scope.BillCountryLong = null;
        $scope.autocompleteData = $scope.empty_autocomplete_data();
        $scope.autocompleteData  = $scope.autocompletePlaces($scope.place_bill, $scope.autocompleteData);

        $scope.BillLatitude = $scope.place_bill.geometry.location.lat();
        $scope.BillLongitude = $scope.place_bill.geometry.location.lng();

        $scope.BillCityLong = $scope.autocompleteData.BuyerCityLong;
        $scope.BillCountryShort = $scope.autocompleteData.BuyerCountryShort;

        $scope.BillCity = $scope.place_bill.formatted_address.split(',')[0].replace(/\s/g, "");
        $scope.BillCountry = $scope.place_bill.formatted_address.split(',')[1].replace(/\s/g, "");
        $('#bill_city').blur();
        $("#bill_city").val($scope.BillCityLong);
        $scope.$apply();
    };

    $scope.getBillAddress = function(bill_address){
        $scope.bill_address = bill_address;
        $scope.BillCityShort = null;
        $scope.BillCityLong = null;

        if(typeof $scope.bill_address!= "object" || !$scope.bill_address){
            $scope.BillCityShort = $scope.bill_address;
            $scope.BillCityLong = $scope.bill_address;
            $scope.BillLatitude = $("[name='bill_latitude']").val();
            $scope.BillLongitude = $("[name='bill_longitude']").val();
            if(initalize_bill_city == false){
                initalize_bill_city = true;
                $scope.BillCountryShort = null;
                $scope.BillCountryLong = null;
                $timeout(function(){
                    $scope.BillCountryShort = userdata.country;
                    $scope.BillCountryLong = $('#bill_country option:selected').text();
                });
            }
            return;
        }
        $scope.BillCountryShort = null;
        $scope.BillCountryLong = null;
        $scope.autocompleteBillAddress = $scope.empty_autocomplete_data();
        $scope.autocompleteBillAddress  = $scope.autocompletePlaces($scope.bill_address, $scope.autocompleteBillAddress);

        $scope.address_bill = [];
        if($scope.autocompleteBillAddress.PointofInterestL || $scope.autocompleteBillAddress.PointofInterestS){
            $scope.address_bill.push($scope.autocompleteBillAddress.PointofInterestL);
        }else{
            $scope.address_bill.push($scope.autocompleteBillAddress.CityRouteLong, $scope.autocompleteBillAddress.neighborhoodLong, $scope.autocompleteBillAddress.CityStreetNLong);
        }

        $scope.address_bill = $scope.address_bill.filter(function (el) {
            return el;
        });

        if($scope.address_bill.length === 0){
            $scope.address_bill.push($scope.autocompleteBillAddress.BuyerCityLong);
        }

        $('#bill_address').blur();
        $('#bill_address').val($scope.address_bill.join(' '));

        $scope.bill_postal = $scope.autocompleteBillAddress.BuyerCityPostalCode;
        $scope.BillCity = $scope.autocompleteBillAddress.BuyerCityLong;
        $scope.BillCityLong = $scope.autocompleteBillAddress.BuyerCityLong;

        $scope.BillLatitude = $scope.bill_address.geometry.location.lat();
        $scope.BillLongitude = $scope.bill_address.geometry.location.lng();

        $scope.BillCountryShort = $scope.autocompleteBillAddress.BuyerCountryShort;
        $scope.BillCountryLong = $scope.autocompleteBillAddress.BuyerCountryLong;

        $('#bill_city').blur();
        $("#bill_city").val($scope.autocompleteBillAddress.BuyerCityLong);
        $scope.place_bill = $scope.autocompleteBillAddress.BuyerCityLong;

        $scope.$apply();
    };


    /**/

    $rootScope.updateCC = function(){
        $scope.ccFirstName = $rootScope.currentUser.info.firstName;

        $scope.CCLastName = $rootScope.currentUser.info.lastName;

    }

    $scope.BuyerFirstName = CCData.ccFirstName;
    $scope.BuyerLastName = CCData.ccLastName;

    $scope.ccFirstName = CCData.ccFirstName;
    $scope.CCLastName  = CCData.ccLastName;

    $scope.showPaymentButton = 'credit_card';

    $scope.Date = function(arg){
        return new Date(arg);
    };

    $scope.changePaymentType = function(type) {
        $scope.paymentType = type;
    }

    $scope.collect_buyer_location = collect_buyer_location;

    $scope.sendEnterPayment = function(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            e.preventDefault();
            return false;
        }
    }

    $scope.noCardSelected = false;
    $scope.formLoading = false;
    $scope.translations = translations;

    $scope.captcha_token = '';
    $scope.captchaSuccess = true;

    const inputPaymentMethod = document.querySelector('input[name="payment_method"]').value;
    const paymentMethod = $scope.paymentMethods.find(method => method.type === inputPaymentMethod);
    $scope.paymentType =  paymentMethod || null;

    $scope.validateSendPaymentForm = function($message) {
        if(!$scope.validateMultipleCheckbox()) {
            return false;
        }
        $scope.shop_form.$setSubmitted(true);

        if(!$scope.validatePhones()) {
            return false;
        }

        $scope.captcha_token = $scope.validate_Captcha();
        if (!$scope.captchaSuccess) {
            makeInfoBar($scope.translations.validationErrors, 'warning', 500, 8000);
            setTimeout(function() {
                $('html, body').animate({
                    scrollTop: $(".input__error").first().offset().top - 150
                }, 800);
            }, 200);

            return false;
        }
        if(!$rootScope.currentUser.isLoggedIn) {
            makeInfoBar($message, 'warning', 500, 8000);
            setTimeout(function(){
                $('html, body').animate({
                    scrollTop: $(".js-inline-auth").offset().top - 150
                }, 800);
            },200);

            return false;
        }
        $scope.shop_form.$setSubmitted(true);
        if ($scope.shop_form.$invalid) {
            if ($scope.shop_form.insurance_terms && $scope.shop_form.insurance_terms.$invalid) {
                const toggleElement = document.querySelector('.js-toggle-insurance-description');
                const descriptionElement = document.querySelector('.js-insurance-description');
                if (toggleElement && descriptionElement) {
                    if (!toggleElement.classList.contains('is-active')) {
                        toggleElement.classList.add('is-active');
                        setTimeout(function() {
                            descriptionElement.style.maxHeight = `${descriptionElement.scrollHeight}px`;
                        }, 200);
                    } else {
                        setTimeout(function() {
                            descriptionElement.style.maxHeight = `${descriptionElement.scrollHeight}px`;
                        }, 200);
                    }
                }
            }

            makeInfoBar($scope.translations.validationErrors, 'warning', 500, 8000);
            setTimeout(function() {
                $('html, body').animate({
                    scrollTop: $(".input__error").first().offset().top - 150
                }, 800);
            }, 200);

            return false;
        }
        if($scope.paymentType === "" && (
            $scope.CCType === "" || $scope.CCType === undefined || $scope.CCType === null)){
            $scope.noCardSelected = true;
            makeInfoBar($scope.translations.validationErrors, 'warning', 500, 8000);
            return false;
        } else {
            $scope.noCardSelected = false;
        }
        return true;
    }

    $scope.sendPayment = function($event, $message) {
        $event.preventDefault();

        if ($scope.validateSendPaymentForm($message)) {
            $scope.formLoading = true;
            $event.target.submit();
        }
    }

    $scope.validate_Captcha = function(){
        if (enableCaptcha == 0 || high_demand_event == 0) {
            return true;
        }

        var c = $('.g-recaptcha').length;
        if (c == 0) {
            return true;
        }

        for (var i = 0; i < c; i++){
            var captchaResponse = grecaptcha.enterprise.getResponse(i);
            if (captchaResponse != ""){
                $scope.captchaSuccess = true;
                $scope.$applyAsync();

                return captchaResponse;
            }
        }
        $scope.captchaSuccess = false;
        $scope.$applyAsync();

        return false;
    };

    $scope.validatePhones = function() {
        var $phones = $('input[type="text"].input-phone');
        var errors = 0;
        var firstPhone = null;
        $($phones).each(function(key, val) {
            var $phone = $(this)[0];
            const itiPhone = intlTelInput.getInstance($phone);
            if (itiPhone) {
                var name = $($phone).attr('name');
                if (firstPhone == null) {
                    firstPhone = name;
                }

                if ($($phone).is('[required]')) {
                    if (itiPhone.getNumber() && !itiPhone.isValidNumber()) {
                        $scope.shop_form[name].$setValidity('phoneValid', false);
                        errors++;
                    } else {
                        $scope.shop_form[name].$setValidity('phoneValid', true);
                    }
                }
            }
        });

        if (errors > 0) {
            makeInfoBar($scope.translations.custom_fields_validation_invalid_phone, 'error', 500, 8000);
            setTimeout(function(){
                $('html, body').animate({
                    scrollTop: $('input[name="'+firstPhone+'"]').first().offset().top - 150
                }, 800);
            },200);
        }
        $scope.$applyAsync();
        return errors === 0;
    };

    $scope.validateMultipleCheckbox = function(){
        var multiples = [];
        var $multiple_checkboxes = $('input[type="checkbox"].multiple-checkbox');
        var result = true;

        if($multiple_checkboxes.length == 0) {
            return result;
        }

        $($multiple_checkboxes).each(function(key, val) {
            var $checkbox = $(this)[0];
            var field_id = $($checkbox).data('field-id');
            var field_limit = $($checkbox).data('limit');
            var field_required = $($checkbox).data('required-input');
            var unique_id = $($checkbox).data('unique-id');

            if (multiples.filter(function(e) { return( e.field_id == field_id && e.unique_id == unique_id); }).length == 0) {
                var choice = {
                    field_id : field_id,
                    field_limit : field_limit,
                    field_required : field_required,
                    unique_id : unique_id,
                }

                multiples.push(choice);
            }
        });


        $(multiples).each(function(key, field) {

            var selected_item_count = $('input[type="checkbox"][data-field-id='+field.field_id+'][data-unique-id='+field.unique_id+']:checked').length;

            if(selected_item_count > field.field_limit){
                makeInfoBar($scope.translations.validationErrors, 'warning', 500, 8000);

                setTimeout(function(){
                    $('html, body').animate({
                        scrollTop: $('input[type="checkbox"][data-field-id="'+field.field_id+'"][data-unique-id='+field.unique_id+']').first().offset().top - 150
                    }, 800);
                },200);
                result = false;
            }

            if(field.field_required && selected_item_count === 0){
                makeInfoBar($scope.translations.validationErrors, 'warning', 500, 8000);

                setTimeout(function(){
                    $('html, body').animate({
                        scrollTop: $('input[type="checkbox"][data-field-id="'+field.field_id+'"][data-unique-id='+field.unique_id+']').first().offset().top - 200
                    }, 800);
                },200);
                result = false;
            }

        });

        $scope.$applyAsync();

        return result;
    }

    if(typeof invoiceType !== 'undefined'){
        $scope.invoiceType = invoiceType;
    }

    $scope.showLoader = function() {
        if (!document.querySelector('.js-checkout-section-loader').classList.contains('is-shown')) {
            document.querySelector('.js-checkout-section-loader').classList.add('is-shown');
            document.querySelector('.js-checkout-section-loader').classList.add('is-animated');
        }
    }

    $scope.hideLoader = function() {
        document.querySelector('.js-checkout-section-loader').classList.remove('is-shown');
        document.querySelector('.js-checkout-section-loader').classList.remove('is-animated');
    }

    $scope.recalculateOrder = function() {
        let startTime = Date.now();
        let minLoadingTime = 500;

        $scope.showLoader();
        $scope.formLoading = true;

        // Wait for the running request to finish
        if ($scope.currentRecalculateRequest) {
            setTimeout(function() {
                $scope.recalculateOrder();
            }, 500);
            return;
        }

        var data = {
            'booking_protect' : $scope.insuranceType === 'insured' ? 1 : 0,
            'payment_method' : $scope.paymentType ? $scope.paymentType.type : null,
        };

        let order_delivery = {
            'order_delivery_type': $scope.order_delivery
        };

        if ($scope.order_delivery === 'sms_delivery') {
            let phone_number_element = document.querySelector("#phone_number");
            const iti = intlTelInput.getInstance(phone_number_element);
            order_delivery.phone_country_code = iti?.getExtension() || '';
            order_delivery.phone_number = iti?.getNumber() || '';
        }

        data.order_delivery = order_delivery;

        $scope.currentRecalculateRequest = $.ajax({
            url: "/shop/recalculate_order",
            type: "POST",
            dataType: 'json',
            data: data,
        });

        $scope.currentRecalculateRequest.done(function (data) {
            if(data.data.redirect_url) {
                window.location = data.data.redirect_url;
            }

            if (data.success == false && data.hasOwnProperty('reason') && data.reason === 'insurance_failed') {
                makeInfoBar(translations.insurance_offer_invalid, "warning", 500, 8000);
                $scope.insuranceType = 'uninsured';
                $scope.$applyAsync();

                return;
            }

            $('.js-ticket-insurance').html(data.data.booking_protect_premium.toFixed(2));
            $('.js-total-amount').val(data.data.total_payment_amount);
            $('.js-checkout-total').html(data.data.total_payment_amount_formatted);

            if (data.data.checkout_text_cc) {
                $('.js-checkout-imp-info-text strong').html(data.data.checkout_text_cc);
            }

            if($scope.paymentType && $scope.paymentType.type === 'revolut_pay'){
                const revolutResponse = data.data.revolutResponse;
                revolutResponse.paymentType = $scope.paymentType.card === 'revolut_pay' ? 'revolut_pay' : 'credit_card';

                window.initRevolutButton(revolutResponse);
            }

            if ($scope.order_delivery && $scope.order_delivery == "sms_delivery" && data?.data?.order_delivery_by_sms_price) {
                let smsOrderDeliveryPriceWrapper = document.getElementById('order_delivery_price_wrapper');
                if (smsOrderDeliveryPriceWrapper){
                    smsOrderDeliveryPriceWrapper.style.display = 'flex';
                    let phone_number_element = document.querySelector("#phone_number");
                    const iti = intlTelInput.getInstance(phone_number_element);
                    if (iti && !iti.getNumber()) {
                        iti.setNumber($scope?.refundPhone || '');
                    }
                }
                $('#order_delivery_price').html(data.data.order_delivery_by_sms_price);
            } else {
                let smsOrderDeliveryPriceWrapper = document.getElementById('order_delivery_price_wrapper');
                if (smsOrderDeliveryPriceWrapper){
                    smsOrderDeliveryPriceWrapper.style.display = 'none';
                }
            }

            $scope.$applyAsync();
        }).fail(function (e) {
            if(e.statusText === 'abort') {
                return;
            }

            $scope.showPaymentButton = false;

            makeInfoBar(translations.generalError, "error", 500, 8000);
            $scope.$applyAsync();
        }).always(function(result) {
            const elapsedTime = Date.now() - startTime;
            if (elapsedTime < minLoadingTime) {
                setTimeout(function() {
                    $scope.hideLoader();
                }, minLoadingTime - elapsedTime);
            } else {
                $scope.hideLoader();
            }

            if (typeof result.success === 'undefined' || (typeof result.success !== 'undefined' && result.hasOwnProperty('success') && result.success !== true)) {
                // log this fail
                setTimeout(function () {
                    $.ajax({
                        url: siteUrl + 'ajax/elastic_log',
                        data: {
                            "message" : 'Error while recalculating order',
                            "data": result
                        },
                        dataType: 'json',
                        type: 'post',
                        success: function (data) {
                            console.log('error logged');
                        }
                    })
                }, 200);
            }

            $scope.currentRecalculateRequest = null;
            $scope.formLoading = false;
            $scope.$applyAsync();
        });
    }

    $scope.disableR1 = false;
    if(typeof disableR1 !== 'undefined'){
        $scope.disableR1 = disableR1;
    }

    $scope.deliveryMethod = 'delivery_eticket'; // uncomented for aircash campaign
    $scope.giftDeliveryMethod = 'delivery_to_the_address'; // uncomented for aircash campaign

    $('.delayed-select2').each(function() {
      $(this).select2({
        dropdownParent: $(this).parent()
      });
    });

    $scope.$watch('invoiceType', function(newVal, oldVal){
        setTimeout(function(){
            $('.delayed-select2').each(function() {
              $(this).select2({
                dropdownParent: $(this).parent()
              });
            });

            if (newVal === 'company') {
                const input = document.querySelector("#bill_phone");
                intlTelInput(input, {
                    separateDialCode: true,
                    initialCountry: entrioDomain,
                    loadUtils: () => itiUtils,
                    hiddenInput: () => ({
                        phone: "bill_phone_number",
                        country: "bill_country_code"
                    }),
                });
            }
        }, 200);
    });

    let firstRun = true;

    $scope.$watch('insuranceType', function(newVal, oldVal) {
        if (firstRun) {
            firstRun = false;
            return;
        }
        $scope.recalculateOrder(newVal, oldVal);
    });
    $scope.$watch('insuranceType', toggleInsuranceTerms);
    $scope.$watch('order_delivery', toggleOrderDeliveries);

    $scope.$watch('paymentType', function (newVal, oldVal) {
        if(!newVal) {
            return;
        }

        if(!$rootScope.currentUser.isLoggedIn) {
            makeInfoBar(window.bootData.sendPaymentMsg, 'warning', 500, 8000);
            setTimeout(function(){
                $('html, body').animate({
                    scrollTop: $(".js-inline-auth").offset().top - 150
                }, 800);
            },200);

            $scope.paymentType = null;
            return false;
        }

        document.querySelector('input[name="payment_method"]').value = newVal?.type;

        if (document.querySelector('input[name="creditID"]')) {
            document.querySelector('input[name="creditID"]').value = newVal?.card;
        }

        if ($scope.paymentType?.type === 'revolut_pay') {
            if($scope.paymentType?.card === 'revolut_pay') {
                $scope.showPaymentButton = 'revolut_pay';
            } else {
                $scope.showPaymentButton = 'revolut_pay_by_card';
            }
        } else {
            $scope.showPaymentButton = 'credit_card';
        }

        $scope.recalculateOrder();

        setTimeout(function(){
            $('.delayed-select2').each(function() {
                $(this).select2({
                    dropdownParent: $(this).parent()
                });
            });
        }, 200);

        $scope.updateDeliveryMethod(); // uncomented for aircash campaign
    }, true);

    function toggleInsuranceTerms() {
        const toggleElement = document.querySelector('.js-toggle-insurance-description');
        const descriptionElement = document.querySelector('.js-insurance-description');

        if (toggleElement && descriptionElement) {
            if ($scope.insuranceType === 'insured' && !toggleElement.classList.contains('is-active')) {
                toggleElement.classList.add('is-active');
                descriptionElement.style.maxHeight = `${descriptionElement.scrollHeight}px`;
            } else if ($scope.insuranceType !== 'insured') {
                toggleElement.classList.remove('is-active');
                descriptionElement.style.maxHeight = '0';
            }
        }
    }

    //TODO: there is an issue here where this is triggered on page load without the customer doing anything
    function toggleOrderDeliveries(newVal, oldVal) {
        const smsOrderDeliveryElement = document.getElementById('send_order_delivery_by_sms_number_wrapper');

        if (smsOrderDeliveryElement) {
            switch (newVal){
                case "sms_delivery":
                    smsOrderDeliveryElement.style.display = 'flex';
                    const input = document.querySelector("#phone_number");
                    intlTelInput(input, {
                        i18n: translation,
                        separateDialCode: true,
                        initialCountry: entrioDomain,
                        loadUtils: () => itiUtils,
                        hiddenInput: () => ({
                            phone: "order_delivery_by_sms_phone_number",
                            country: "order_delivery_by_sms_country_code"
                        }),
                    });
                    break;
                case "no_delivery":
                default:
                    smsOrderDeliveryElement.style.display = 'none';
            }
        }

        $scope.recalculateOrder();
    }

    $(document).ready(function() {
        const paymentMethodInput = document.querySelector('input[name="payment_method"]')
        if(paymentMethodInput) {
            document.querySelector('input[name="payment_method"]').value = $scope.paymentType?.type;
        }

        const creditIDInput= document.querySelector('input[name="creditID"]')
        if(creditIDInput) {
            document.querySelector('input[name="creditID"]').value = $scope.paymentType?.card;
        }

        if (insuranceEnabled) {
            $scope.insuranceType = 'insured';

            const toggleElement = document.querySelector('.js-toggle-insurance-description');
            const descriptionElement = document.querySelector('.js-insurance-description');

            if (toggleElement && descriptionElement) {
                if (!toggleElement.classList.contains('is-active')) {
                    toggleElement.classList.add('is-active');
                    descriptionElement.style.maxHeight = `${descriptionElement.scrollHeight}px`;
                }
            }
        }

        const params = new URLSearchParams(window.location.search);
        const error_message = params.get('error_message');
        if (error_message) {
                makeInfoBar(error_message, 'error', 500, 8000);
                // Remove error_message from URL
                params.delete('error_message');
                const newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
                window.history.replaceState({}, '', newUrl);
        }
    });

    // uncommented for aircash campaign
    $scope.showGiftDeliveryInput = true;
    $scope.dontWantGiftTowel = false;
    $scope.towelDeliveryRequired = true;
    $scope.updateGiftDelivery = function(input){
        if(input == 'dont_want_gift'){
            $scope.dontWantGiftTowel = true;
            $scope.towelDeliveryRequired = false;
            $scope.showGiftDeliveryInput = false;
        }else{
            $scope.dontWantGiftTowel = false;
            $scope.towelDeliveryRequired = true;
            $scope.showGiftDeliveryInput = true;
        }
        $scope.$applyAsync();
    }

    $scope.disableEticketDelivery = false;
    $scope.disableHomeDelivery = true;
    $scope.showGiftDelivery = false;
    $scope.updateDeliveryMethod = function(){
        if(new Date() > new Date('2023-08-05')){
            $scope.dontWantGiftTowel = true;
            $scope.towelDeliveryRequired = false;
            $scope.showGiftDeliveryInput = false;
            return;
        }

        if ($scope.paymentType.card == 'AIRCASH'){
            $scope.disableEticketDelivery = true;
            $scope.disableHomeDelivery = false;
            $scope.giftDeliveryMethod = 'delivery_to_the_address';
            $scope.deliveryMethod = 'delivery_eticket';
            $scope.showGiftDelivery = true;
            $scope.updateDeliveryFields();
        }else{
            $scope.disableEticketDelivery = false;
            $scope.disableHomeDelivery = true;
            $scope.deliveryMethod = 'delivery_eticket';
            $scope.giftDeliveryMethod = false;
            $scope.showGiftDelivery = false;
            $scope.updateDeliveryFields(true);
        }
        $scope.$applyAsync();
    }

    $scope.updateDeliveryFields = function(reset = false){
        $scope.ticketDeliveryName = reset || !$rootScope.currentUser.info.firstName ? '' : $rootScope.currentUser.info.firstName + ' ' + $rootScope.currentUser.info.lastName;
        $scope.$applyAsync();
    }


    $scope.updateCCType = function() {
        var a = $("#CCNumber").val();
        if (void 0 !== a) {
            cardType = creditCardType(a);

            if (cardType === "CCDiners")
                $scope.CCType = "Diners";

            if (cardType === "CCAMEX")
                $scope.CCType = "AMEX";

            if(cardType === "CCVISA")
                $scope.CCType = "VISA";

            if(cardType === "CCECMC")
                $scope.CCType = "ECMC";

            if(cardType === "CCMaestro")
                $scope.CCType = "Maestro";

        }
    }


    function creditCardType(a) {
        a = a.toString(), firstDigit = parseInt(a.slice(0, 1), 10), firstTwoDigits = parseInt(a.slice(0, 2), 10), firstThreeDigits = parseInt(a.slice(0, 3), 10);
        var b = "invalid";
        return 34 == firstTwoDigits || 37 == firstTwoDigits ? b = "CCAMEX" : 4 == firstDigit ? b = "CCVISA" : firstTwoDigits >= 51 && firstTwoDigits <= 55 ? b = "CCECMC" : 36 == firstTwoDigits || 38 == firstTwoDigits || firstThreeDigits >= 300 && firstThreeDigits <= 305 ? b = "CCDiners" : (6 == firstDigit || 50 == firstTwoDigits || 56 == firstTwoDigits || 57 == firstTwoDigits || 58 == firstTwoDigits) && (b = "CCMaestro"), b
    }
}]);

window.entrio.entrioApp.controller('refundPageController', ['$scope', '$rootScope', function($scope, $rootScope) {
    $scope.globalSiteUrl = baseUrlRefunds;
    if ($scope.globalSiteUrl.slice(-1) === "/") {
        $scope.globalSiteUrl =  $scope.globalSiteUrl.slice(0, -1);
    }
    $scope.langs = thisPage.lang;
    $scope.canceledEvents = thisPage.canceledEvents;

    setTimeout(function() {
        $('.delayed-select2').each(function() {
          $(this).select2({
            dropdownParent: $(this).parent()
          });
        });
    });

    $scope.selectedEvent = "default";
    $scope.step_ticket_code = false;
    $scope.ticket_code = {
        value: ""
    };

    $scope.location = {
        online: false,
        outlet: false
    };

    $scope.buyer = {
        name : "",
        email : "",
        iban : "",
        city: "",
        country: refund_userdata.country,
        postal_code: "",
        address: "",
    }

    $scope.refund_note = "";

    $scope.showSteps = function(el){
        $scope.selectedEvent = el;
        $scope.step_ticket_code = true;
        $scope.$applyAsync();
        setTimeout(function() {
            rescaleCaptcha();
        }, 300);
    }


    $scope.choseLocation = function(location){
        if(location == 'online_web'){
            $scope.location.online = true;
            $scope.location.outlet = false;
            $scope.$applyAsync();
            setTimeout( function(){
                $('html, body').animate({
                    scrollTop: $("#online_instructions").offset().top - 100
                }, 1000);
            });
        }else{
            $scope.location.online = false;
            $scope.location.outlet = true;
            $scope.$applyAsync();
            setTimeout( function(){
                $('html, body').animate({
                    scrollTop: $("#pos_instructions").offset().top - 100
                }, 1000);
            });
        }

        $scope.$applyAsync();
    }

    $scope.tickets = [];

    $scope.ticketData = function() {
        return {
            code: "",
            photo: null,
            refunded: false,
            dropzone :{
                name: null,
                path: null,
                size: null,
                b64: null
            }
        };
    };

    $scope.tickets.push($scope.ticketData());

    $scope.addNewTicket = function(){
        $scope.tickets.push($scope.ticketData());
        $scope.$applyAsync();

        setTimeout( function(){
            var id_new_ticket = '#ticket_number_'+($scope.tickets.length-1);
            $('html, body').animate({
                scrollTop: $(id_new_ticket).offset().top - 100
            }, 1000);
        });
    };

    $scope.removeTicket = function(index){
        $scope.tickets.splice(index, 1);
        $scope.$applyAsync();

        setTimeout( function(){
            var size = $('.ticket-image-refund').length;
            for(var i = index; i < size; i++){
                var element_id = '#ticket-image-refund-'+i;
                var dropzoneControl = $(element_id).length ? $(element_id)[0].dropzone : null;
                if($scope.tickets[i].dropzone.name == null){
                    return;
                }
                var mockFile = { name: $scope.tickets[i].dropzone.name, size: $scope.tickets[i].dropzone.size };
                dropzoneControl.removeAllFiles();

                dropzoneControl.options.addedfile.call(dropzoneControl, mockFile);

                dropzoneControl.options.thumbnail.call(dropzoneControl, mockFile, $scope.tickets[i].dropzone.b64);
            }

            var id_new_ticket = '#ticket_number_'+($scope.tickets.length-1);
            $('html, body').animate({
                scrollTop: $(id_new_ticket).offset().top - 100
            }, 1000);
        });
    };

    //images uplaod
    $scope.uploadedFile = function(element, ticket) {
        var reader = new FileReader();
        reader.onload = function(event) {
            $scope.$apply(function($scope) {
                $scope.src = event.target.result;
                ticket.photo = $scope.src;
            });
        };
        reader.readAsDataURL(element.files[0]);
    };

    $scope.captchaEnabled = thisPage.captchaEnabled;
    $scope.captchaToken = null;
    $scope.captchaSuccess = true;
    $scope.captchaCheckTicketCodeSuccess = true;
    $scope.iban_valid = true;
    $scope.sendingRefundRequest = false;

    $scope.sendRequest = function(){
        $scope.refund_form.$setSubmitted(true);

        $scope.captchaToken = $scope.validateRefundCaptchas(false);
        if (!$scope.captchaSuccess) {
            return false;
        }

        $scope.validate_IBAN($scope.buyer.iban);
        if ($scope.refund_form.$invalid || !$scope.iban_valid) {
            $scope.animateErrorMessage();
            return false;
        }

        $scope.send_data = {
            buyer: $scope.buyer,
            tickets: $scope.tickets,
            event_id: $scope.selectedEvent,
            refund_note: $scope.refund_note,
            captcha_token: $scope.captchaToken,
        };
        $scope.sendingRefundRequest = true;
        $.ajax({
            url: $scope.globalSiteUrl + "/refund/new_refund",
            type: "POST",
            data: $scope.send_data,
        }).done(function (data) {
            $scope.resetTicketRefunded();
            $scope.sendingRefundRequest = false;
            data = JSON.parse(data);
            if(data.status==false){
                if(data.data){
                    data.data.forEach(function (ticket_code) {
                        $scope.ticketIsCanceled(ticket_code);
                    });
                    $scope.animateErrorMessage();
                }
                makeInfoBar(data.message, 'warning', 500, 8000);
                $scope.$apply();
            }else{
                //makeInfoBar(data.message, "Green", 500, 8000);
                $scope.$applyAsync();
                $('#refund_modal').remove();
                $('.js-refund-page').append(data.html_modal);
                $('#refund_modal')[0].style.display='block';
                $('html').css('pointer-events', 'none');
                $('#confirm_refund_notice').css('pointer-events', 'all');
            }
        }).fail(function () {
            $scope.sendingRefundRequest = false;
            makeInfoBar("Error", 'error', 500, 8000);
            $scope.$apply();
        });
    };

    $scope.captchaId = null;
    $scope.validateRefundCaptchas = function(firstCaptchaCheck){
        if (enableCaptcha == 0) {
            return true;
        }

        var c = $('.g-recaptcha').length;
        if (c == 0) {
            return true;
        }

        for (var i = 0; i < c; i++) {
            if (!firstCaptchaCheck) {
                var currentItem = $('.g-recaptcha').eq(i);

                if (!currentItem.hasClass('second-captcha')) {
                    continue;
                }
            }
            var captchaResponse = grecaptcha.enterprise.getResponse(i);
            if (captchaResponse != ""){
                $scope.captchaId = i;
                if (firstCaptchaCheck) {
                    $scope.captchaCheckTicketCodeSuccess = true;
                } else {
                    $scope.captchaSuccess = true;
                }
                $scope.$applyAsync();

                return captchaResponse;
            }
        }
        if (firstCaptchaCheck) {
            $scope.captchaCheckTicketCodeSuccess = false;
        } else {
            $scope.captchaSuccess = false;
        }
        $scope.$applyAsync();

        return false;
    };


    $scope.validate_IBAN = function(iban){
        $scope.iban_valid = IBAN.isValid(iban);
        $scope.$applyAsync();
    };

    $scope.ticketIsCanceled = function(ticket_code){
        var index = $scope.tickets.findIndex(i => i.code == ticket_code);
        if(index >= 0){
            $scope.tickets[index].refunded = true;
        }
        $scope.$applyAsync();
    };

    $scope.animateErrorMessage = function(){
        setTimeout(function(){
            $('html, body').animate({
                scrollTop: $(".error-message span").offset().top - 80
            }, 800);
        });
    }

    $scope.resetTicketRefunded = function(){
        $scope.tickets.forEach(function (ticket) {
            ticket.refunded = false;
        });
        $scope.$applyAsync();
    }

   $scope.addDropzone = function(index, ticket){
       Dropzone.autoDiscover = false;
       var element_id = '#ticket-image-refund-' + index;
       var dropzoneControl = $(element_id).length ? $(element_id)[0].dropzone : null;
       if (dropzoneControl) {
           dropzoneControl.destroy();
       }
       // Init plupload
       setTimeout(function() {
           $(element_id).dropzone({
               dictDefaultMessage: translations.uploadMessage,
               acceptedFiles: "image/*",
               maxFiles: 1,
               url: baseUrl + 'files/plupload',
               maxfilesexceeded: function(file) {
                   this.removeAllFiles();
                   this.addFile(file);
               },
               init: function() {
                   this.on("sending", function(file) {
                       var custom_name = Date.now() + '_' + file.name;
                       this.options.renameFilename = function(file){
                           return custom_name;
                       };
                   });
                   this.on("success", function(file, data) {
                       data = JSON.parse(data);
                       if(data.success){
                           var reader = new FileReader();
                           reader.onload = function(event) {
                               $scope.$apply(function($scope) {
                                   $scope.b64 = event.target.result;
                                   ticket.dropzone.b64 = $scope.b64;
                               });
                           };
                           reader.readAsDataURL(file);

                           ticket.dropzone.path = data.upload_data.full_path;
                           ticket.dropzone.size = data.upload_data.file_size;
                           ticket.dropzone.name = data.upload_data.file_name;
                       }
                   });
               }

           });
       });
   }

    $scope.checkTicketCode = function() {
        $scope.captchaCheckTicketCodeToken = $scope.validateRefundCaptchas(true);
        if (!$scope.captchaCheckTicketCodeSuccess) {
            return false;
        }

        $.ajax({
            url:  $scope.globalSiteUrl +"/refund/check_ticket_code",
            dataType: 'json',
            type: "POST",
            data: {
                'event_id': $scope.selectedEvent,
                'ticket_code' : $scope.ticket_code.value,
                captcha_token: $scope.captchaCheckTicketCodeToken,
            },
            success: function (data) {
                if (data.data.type == 'online') {
                    $scope.choseLocation('online_web');
                } else if (data.data.type == 'pos') {
                    $scope.tickets[0].code = $scope.ticket_code.value;
                    $scope.choseLocation('partner_pos');
                } else {
                    if (enableCaptcha != 0) {
                        grecaptcha.enterprise.reset($scope.captchaId);
                    }
                    $scope.location.online = false;
                    $scope.location.outlet = false;
                    makeInfoBar(data.message, detect_notification_severity(data), 500, 8000);
                }
                $scope.$applyAsync();
            }
        });
    }

    $scope.redirectTickets = function(){
        window.location.href = $scope.globalSiteUrl + '/tickets';
    }
}]);


function FormatNumberBy3(num, decpoint, sep, newSep) {
    // check for missing parameters and use defaults if so
    if (arguments.length == 2) {
        sep = ",";
    }
    if (arguments.length == 1) {
        sep = ",";
        decpoint = ".";
    }
    // need a string for operations
    num = num.toString();
    // separate the whole number and the fraction if possible
    a = num.split(decpoint);
    x = a[0]; // decimal
    y = a[1]; // fraction
    z = "";


    if (typeof (x) != "undefined") {
        // reverse the digits. regexp works from left to right.
        for (i = x.length - 1; i >= 0; i--)
            z += x.charAt(i);
        // add seperators. but undo the trailing one, if there
        z = z.replace(/(\d{3})/g, "$1" + sep);
        if (z.slice(-sep.length) == sep)
            z = z.slice(0, -sep.length);
        x = "";
        // reverse again to get back the number
        for (i = z.length - 1; i >= 0; i--)
            x += z.charAt(i);
        // add the fraction back in, if it was there
        if (typeof (y) != "undefined" && y.length > 0)
            x += newSep + y;
    }

    return x;
}


window.entrio.entrioApp.filter('formatCurrency', [function() {
    return function(amount, scope) { //1 = January
        if (amount === undefined || amount === null)
            return 0;
        amount = amount.toFixed(2);

        amount = FormatNumberBy3(amount, ".", ".", ",");


        var currencySymbol = "Kn";
        var returnVar = "";

        returnVar = amount + " " + currencySymbol;


        return returnVar;
    }
}]);

$(function() {
    if ($("#latlng").length > 0 && $("#gMap").length > 0) {
        if(typeof google == "undefined") {
            return;
        }

        const temp = $("#latlng").val().split(',');
        const latlng = new google.maps.LatLng(parseFloat(temp[0]), parseFloat(temp[1]));

        const mapOptions = {
            zoom: 15,
            streetViewControl: false,
            mapTypeControl: false,
            center: latlng,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        }

        const map = new google.maps.Map(document.getElementById("gMap"), mapOptions);

        const marker = new google.maps.Marker({
            map: map,
            draggable: false,
            position: latlng,
            icon: {
                url: baseUrl + 'images/map/entrio_door_gmaps_36.png'
            }
        });
    }
});

function currency(amount, currency, convert_to_currency){
    const showLocalSymbol = true; //depending on language/site - same as in backend
    const currencies = {
        HRK: {
            curr_name:'HRK',
            curr_symbol:' kn',
            curr_symbol_suffix:1,
            curr_thousand_separator:'.',
            curr_decimal_separator:','
        },
        EUR:{
            curr_name:'EUR',
            curr_symbol:' €',
            curr_symbol_suffix:1,
            curr_thousand_separator:'.',
            curr_decimal_separator:','
        },
        BAM:{
            curr_name:'BAM',
            curr_symbol:' KM',
            curr_symbol_suffix:1,
            curr_thousand_separator:'.',
            curr_decimal_separator:','
        }// TODO fetch this from DB
    };
    const xRates = {
        HRK: 7.5235,
        EUR: 1
    }

    function formatCurrency(am, curr){
        //am = Math.ceil(am);
        am = am == null ? 0 : am;
        const symbolUsed = showLocalSymbol ? currencies[curr]['curr_symbol'] : currencies[curr]['curr_name'];
        return (currencies[curr]['curr_symbol_suffix'] == 1 ? am + symbolUsed : symbolUsed + am);
    }

    if(convert_to_currency !== undefined){
        amount = amount * (xRates[convert_to_currency] / xRates[currency]);
        currency = convert_to_currency;
    }
    return formatCurrency(amount, currency);
}

window.entrio.entrioApp.controller('roomsPageController', ['$scope', '$rootScope', '$timeout', function ($scope, $rootScope, $timeout) {
    $("#close_stream_help").on("click", function() {
        window.entrio.closeModal("#stream_help_modal");
        if(document.getElementById("myNav").style.height == "100%"){
            document.getElementById("myNav").style.height = "0%";
        }
    });
    $(".open_stream_help").on("click", function() {
        setTimeout(function () {
            window.entrio.showModal("#stream_help_modal");
            $("#stream_help_modal").on("click", function(evt) { evt.stopPropagation(); });
            var data = {
                'event_id':globalEventId,
                'field': 'help_popup_open_count'
            };
            $.ajax({data: data, dataType: 'json', type: "POST",
                url: siteUrl + 'ajax/increment_user_events_stream_field/'+globalEventId
            });

            var speed_data = {
                'conn_type' : false,
                'conn_speed' : false,
            }
            var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
            if(connection) {
                speed_data.conn_type = connection.effectiveType ? connection.effectiveType : connection.type;
                speed_data.conn_speed = connection.downlink;
            }

            $.ajax({data: speed_data, dataType: 'json', type: "POST",
                url: siteUrl + 'ajax/save_speedtest_data/'+globalEventId
            });
        }, 100); });

    $scope.setProfilePic = function(){
        $('#reg_profile_pic').css('background', "url('" + thisPage.user.profile_picture + "')");
        $('#reg_profile_pic').css('background-size', "cover");
    }

    $("#reg_profile_pic").dropzone({

        'url': function () {
            return ""; // this is how you set the url
        },
        method: "POST",
        maxFilesize: "5",
        autoProcessQueue: false,
        autoQueue: false,
        uploadMultiple: false,
        acceptedFiles: ".png,.jpeg,.jpg",
        init: function () {
        },
        addedfile: function (file) {
            var _this = this;
            var needsCropping = true;
            reader = new FileReader();
            reader.onload = function (event) {
                var tempImage = new Image();
                var imgHeight;
                var imgWidth;
                tempImage.src = event.target.result;
                tempImage.onload = function () {
                    imgWidth = this.width;
                    imgHeight = this.height;
                    if (imgWidth  == imgHeight) {
                        needsCropping = false;
                        $('#reg_profile_pic').css('background', "url('" + tempImage.src + "')");
                        $('#reg_profile_pic').css('background-size', "cover");
                        $scope.user_data_registration.profile_picture = tempImage.src;
                    } else {
                        $("html, body").animate({scrollTop: 0}, "slow");
                        base64 = event.target.result;
                        launchPosterEditor(base64);
                    }
                };
            };
            reader.readAsDataURL(file);
        },
        thumbnail: function () {
        }
    });

    function launchPosterEditor(image) {
        $('#image-crop-modal').show();
        document.getElementById('image-crop').setAttribute('src', image);
        var image = document.getElementById('image-crop');
        posterCropper = new Cropper(image, {
            autoCropArea: 1,
            viewMode: 3,
            dragMode: 'crop',
            minCropBoxHeight: 50,
            aspectRatio: 1,
            zoomOnWheel: false
        });

        modalFunctions();
        cropperAdvancedOptions(posterCropper);
    }

    function cropperAdvancedOptions(cropper){
        $('#btn-image-rotate-right').on('click', function (e) {
            cropper.rotate(45);
        });
        $('#btn-image-rotate-left').on('click', function (e) {
            cropper.rotate(-45);
        });
        $('#btn-image-zoom-in').on('click', function (e) {
            cropper.zoom(0.1);
        });
        $('#btn-image-zoom-out').on('click', function (e) {
            cropper.zoom(-0.1);
        });
        $('#btn-image-move-up').on('click', function (e) {
            cropper.move(0, -10);
        });
        $('#btn-image-move-down').on('click', function (e) {
            cropper.move(0, 10);
        });
        $('#btn-image-move-right').on('click', function (e) {
            cropper.move(10,0);
        });
        $('#btn-image-move-left').on('click', function (e) {
            cropper.move(-10,0);
        });
        $('#btn-image-scale-x').on('click', function (e) {
            if(cropper.getImageData().scaleX == 1 || cropper.getImageData().scaleX == undefined){
                cropper.scaleX(-1);
            }else{
                cropper.scaleX(1);
            }
        });
        $('#btn-image-scale-y').on('click', function (e) {
            if(cropper.getImageData().scaleY == 1 || cropper.getImageData().scaleY == undefined){
                cropper.scaleY(-1);
            }else{
                cropper.scaleY(1);
            }
        });
    }

    function modalFunctions() {

        $('#btn-image-crop-ok').on('click', function (e) {
            e.preventDefault();

            if (typeof posterCropper !== 'undefined') {
                var posterCanvas = posterCropper.getCroppedCanvas({
                    width: 300,
                    height: 400,
                });
                if (posterCanvas !== null && posterCanvas !== undefined) {
                    $('#reg_profile_pic').css('background', "url('" + posterCanvas.toDataURL() + "')");
                    $('#reg_profile_pic').css('background-size', "cover");
                    $scope.user_data_registration.profile_picture = posterCanvas.toDataURL();
                    $('#image-crop-modal').fadeOut("fast", function () {
                        posterCropper.destroy();
                    });
                    $("html, body").animate({scrollTop: 0}, "slow");
                }
            }

        });

        $('#btn-image-crop-cancel').on('click', function (e) {
            e.preventDefault();
            $('#image-crop-modal').fadeOut("fast", function () {
                if (typeof posterCropper !== 'undefined') {
                    posterCropper.destroy();
                }
                if (typeof bannerCropper !== 'undefined') {
                    bannerCropper.destroy();
                }
            });
            $("html, body").animate({scrollTop: 0}, "slow");
        });


        $(".modal-overlay").click(function (e) {
            $('#image-crop-modal').fadeOut("fast", function () {
                if (typeof posterCropper !== 'undefined') {
                    posterCropper.destroy();
                }
                if (typeof bannerCropper !== 'undefined') {
                    bannerCropper.destroy();
                }
            });

        });
    }

    $scope.globalSiteUrl = baseUrl;
    if ($scope.globalSiteUrl.slice(-1) === "/") {
        $scope.globalSiteUrl =  $scope.globalSiteUrl.slice(0, -1);
    }

        $('#entrioLoader').hide();

    $(".stream-card-actions").click(function (evt){
        evt.preventDefault();
        var redirect_url = $(this).attr('data-redirect');
        if(redirect_url){
            window.location.href = redirect_url;
        }
    });

    $(".stream-card").click(function (evt){
        var redirect_url = $(this).attr('data-redirect');
        if(redirect_url){
            window.location.href = redirect_url;
        }
    });

    $(".stream-card-redirect").click(function (evt){
        var redirect_url = $(this).attr('data-redirect');
        if(redirect_url){
            window.location.href = redirect_url;
        }
    });

    $scope.user_data_registration = thisPage.user;
    $scope.user_id = userData.userId;

    $scope.enter_event = function(){
        $scope.conference_register_form.$setSubmitted(true);

        if ($scope.conference_register_form.$invalid) {
            return false;
        }

        $.ajax({
            url:  $scope.globalSiteUrl +"/my_events_copy/update_profile_data/" + $scope.user_id,
            dataType: 'json',
            type: "POST",
            data: $scope.user_data_registration,
            success: function (data) {
                makeInfoBar(data.message, detect_notification_severity(data), 500, 8000);
                if (data.success) {
                    window.location.href = thisPage.lobby_url;
                }
            },
            error: function(){
                makeInfoBar("Error", 'error', 500, 8000);
                $scope.$apply();
            }
        });
    }

}]);


window.entrio.entrioApp.controller('urlStreamPageController', ['$scope', '$rootScope', '$timeout', function ($scope, $rootScope, $timeout) {

    $scope.globalSiteUrl = baseUrl;
    if ($scope.globalSiteUrl.slice(-1) === "/") {
        $scope.globalSiteUrl =  $scope.globalSiteUrl.slice(0, -1);
    }

    $('#entrioLoader').hide();


    $scope.user_data_registration = thisPage.user;

    $scope.enter_event = function(){
        $scope.conference_register_form.$setSubmitted(true);

        if ($scope.conference_register_form.$invalid) {
            return false;
        }

        $.ajax({
            url:  $scope.globalSiteUrl +"/my_events_copy/update_user_basic_data/" + globalEventId + "/" + $scope.user_data_registration.access_code,
            dataType: 'json',
            type: "POST",
            data: $scope.user_data_registration,
            success: function (data) {
                makeInfoBar(data.message, detect_notification_severity(data), 500, 8000);
                if (data.success) {
                    window.location.href = thisPage.stream_url+'&confirmed=1';
                }
            },
            error: function(){
                makeInfoBar("Error", 'error', 500, 8000);
                $scope.$apply();
            }
        });
    }

}]);
window.entrio.entrioApp.controller('streamPageController', ['$scope', '$rootScope', function($scope, $rootScope) {

    $scope.ratings = null;

    $("#confirm_survey_button").on("click", function() {
        $scope.ratings = angular.copy(thisPage.ratings);
        $('.myRating_textarea').each(function() {
            $scope.ratings.push({'survey_field_id' : $(this).first().data("survey-field-id"), 'rating' : $(this).first().val()})
        });
        $.ajax({
            url: siteUrl + "ajax/save_survey/" + globalEventId + '/' + thisPage.event.room_id,
            data: {'data' : JSON.stringify($scope.ratings)},
            type: "POST",
            dataType: 'json'
        }).done(function(data) {
            if(!data.status){
                makeInfoBar(data.message, 'success', 500, 8000);
                return false;
            }
            if(thisPage.event.room_id){
                thisPage.event.event_url = 'lobby';
            }
            location.href=thisPage.event.event_url;
            window.entrio.closeModal("#experience_survey_modal");
        });
    });
}]);

window.entrio.entrioApp.controller('profilePageController', ['$scope', '$rootScope', '$timeout', function ($scope, $rootScope, $timeout) {
    $scope.globalSiteUrl = baseUrl;
    $scope.location_id = location_id;
    $scope.profile_page_id = profile_page_id;

    $scope.featured_events_rows = 1;
    $scope.featured_load_more_disabled = false;
    $scope.featured_has_more = true;
    $scope.load_featured_events = function() {
        $scope.featured_load_more_disabled = true;
        $scope.$applyAsync();

        $.ajax({
            url:  $scope.globalSiteUrl +"pages/load_featured_events",
            dataType: 'json',
            type: "POST",
            data: {
                'featured_events_rows': $scope.featured_events_rows,
                'location_id' : $scope.location_id,
                'profile_page_id' : $scope.profile_page_id
            },
            success: function (data) {
                $('#profile-page-featured-events').append(data.html);
                $scope.featured_events_rows++;
                $scope.featured_load_more_disabled = false;
                $scope.featured_has_more = data.has_more;

                const itemLists = document.querySelectorAll('.js-track-view-item-list');
                const secondLastListItems = itemLists[itemLists.length - 2].querySelectorAll(':scope .js-track-select-item');
                let secondLastListLastItemIndex = Number(secondLastListItems[secondLastListItems.length - 1].dataset.index)
                const lastItemList = itemLists[itemLists.length - 1];

                lastItemList.querySelectorAll(':scope .js-track-select-item').forEach(el => {
                    secondLastListLastItemIndex++;
                    el.dataset.index = secondLastListLastItemIndex;

                    el.addEventListener('click', event => {
                        event.preventDefault();
                        window.track.trackSelectItem(event.currentTarget.dataset)
                    })
                })

                window.track.trackViewItemList(lastItemList);

                $scope.$applyAsync();
            }
        });
    }


    $scope.past_events_rows = 1;
    $scope.past_load_more_disabled = false;
    $scope.past_has_more = true;
    $scope.load_past_events = function() {
        $scope.past_load_more_disabled = true;
        $scope.$applyAsync();

        $.ajax({
            url:  $scope.globalSiteUrl +"pages/load_past_events",
            dataType: 'json',
            type: "POST",
            data: {
                'past_events_rows': $scope.past_events_rows,
                'location_id' : $scope.location_id,
                'profile_page_id' : $scope.profile_page_id
            },
            success: function (data) {
                $('#profile-page-past-events').append(data.html);
                $scope.past_events_rows++;
                $scope.past_load_more_disabled = false;
                $scope.past_has_more = data.has_more;
                $scope.$applyAsync();
            }
        });
    }

}]);
